import WebsiteLayout from '../../layouts/WebsiteLayout';
import { Typography, Container, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

const LegalTerms = () => {
  const { t } = useTranslation();

  return (
    <WebsiteLayout>
      <Container>
        <Box marginTop="50px">
          <Typography marginTop="12px" variant="p" fontWeight={600}>
            Dernière mise à jour Janvier 2025
          </Typography>
        </Box>
        <Box marginBottom="25px">
          <Typography marginTop="12px" variant="p" fontWeight={400}>
            A french version will follow
          </Typography>
        </Box>
        <Box marginBottom="25px">
          <Typography marginTop="12px" variant="p">
            CE CONTRAT EST VALIDE POUR LES CONSOMMATEURS ET LES ENTREPRISES
            PARTICIPANTES - THIS CONTRACT IS VALID FOR CONSUMERS AND
            PARTICIPATING COMPANIESNODE TECHNOLOGIES, INC. CUSTOMER PRIVACY
            STATEMENT‍NODE TECHNOLOGIES, INC. (“COMPANY”) values your privacy.
             To learn more about what personal and user data COMPANY collects,
            uses, retains and shares; how we protect your personal data; and
            what choices and means of control you have over your personal data,
            please read this statement in its entirety.This privacy statement
            was last updated on January 31,2025.  If we make important changes
            to this privacy statement, we will post a notice on our website
            and/or contact our customers as appropriate or as required by
            applicable law.  ‍Table of ContentsWhat does this privacy statement
            cover?What personal, user and product data does COMPANY collect and
            how does COMPANY use and share the personal data it collects?Does
            COMPANY use cookies and related technologies on its websites?Does
            COMPANY collect personal data from children?How long does COMPANY
            retain the personal data it collects?Does COMPANY sell personal
            data?Does COMPANY transfer personal data across borders?How does
            COMPANY protect personal data?How can I review, correct, amend or
            delete my personal data?How can I contact COMPANY?What does this
            privacy statement cover?This statement describes COMPANY’s customer
            privacy practices for our COMPANY-branded global websites, COMPANY
            applications, COMPANY services, COMPANY customer sales and marketing
            activities, and COMPANY customer services and support functions,
            among others.  This statement does not apply to COMPANY’s employee
            data practices.Please also note that certain COMPANY websites, or
            software experiences may have links to third-party websites or
            services.  In most cases, those third-party resources are subject to
            the privacy practices and policies of those third parties and not
            COMPANY.What personal, user and product data does COMPANY collect
            and how does COMPANY use and share the personal data it
            collects?COMPANY may collect certain categories of data about you
            when you use our websites; use our services; receive our marketing
            communications; interact with our customer service and support
            teams; and in other contexts.  The data we collect can be broadly
            categorized as follows:Personal Data:  This is individually
            identifiable data that you may choose to provide us.  This may
            include basic information such as your email address and phone
            number, or more sensitive information such as your full date of
            birth or your payment information.User Data:  This is data that we
            collect from users of our services.  User data could include
            personal data such as your unique COMPANY user ID or account
            username and password, but sometimes this user data is anonymous or
            “pseudonymous”, i.e., certain user data that could be made
            identifiable if associated with personal data.Location Data: This is
            data we collect that help us determine a location based on your IP
            address in order to customize our Service and for other uses
            consistent with this Privacy Statement.COMPANY has various uses for
            your personal and user data you provide to us.  Here are the
            principal contexts in which we may use, retain and share your
            personal and user data:Websites and Account Management:  Most often,
            you may browse our websites without providing any personal data to
            us.  However, if you choose to establish a user account with
            COMPANY, engage in e-commerce, sign up for marketing communications,
            or interact with our customer service teams or participate in a
            forum on our website, we will likely need to collect some personal
            or user data from you.  In addition, our web servers automatically
            collect certain data by default, such as IP addresses and other
            activity logs.  This type of data is used for website security and
            site improvement purposes.  Much of that data is not readily
            identifiable and is usually kept anonymous.  In order to maintain
            and improve our websites, COMPANY uses third party hosting, content
            management and security partners, vendors and suppliers.Sales: If
            you decide to purchase a service from COMPANY, we will need to
            collect certain personal data from you, including payment-related
            information.  Typically, we use third party partners, vendors and
            suppliers, such as payment processing companies during our
            sales.‍Marketing & Social Media:  You may choose to receive COMPANY
            marketing communications, participate in an event/contest/promotion
            with us, or connect with COMPANY via social media.  If you do so, we
            will collect certain personal data about you, such as your contact
            information, social media profile information and, in order to
            determine your eligibility for a contest or promotion, your full or
            partial dates of birth.  COMPANY may share your personal data with
            our marketing agencies and partners to carry out our marketing
            campaigns, contests and promotions.  If you wish to unsubscribe from
            our marketing, please follow the opt-out link in the communications
            you receive from us; update your contact preferences in your COMPANY
            account settings; or click here.Product Registration:  If you use
            COMPANY services, you may choose to establish an COMPANY user
            account. An COMPANY user account profile may include your username,
            password, settings, preferences, contact information, device ID
            information, and related data.  COMPANY may share this information
            with other COMPANY subsidiaries and affiliates and vendors and
            suppliers, such as third-party hosting partners.  Certain COMPANY
            product settings, preference information, applications history and
            location-based information may be used by COMPANY product
            development and improvement and customer service teams if you choose
            to enable enhanced customer support services.  Customer Service &
            Support:  If you choose to interact with COMPANY customer service
            and support – whether it be via our website, social media, chat,
            email or phone – COMPANY customer service teams (some of whom work
            for outsourced vendors and suppliers of COMPANY) may have access to
            your account information, product information, contact information
            and payment information.  You may also be required to answer certain
            security questions to verify your identity and your call or session
            with COMPANY customer support may be recorded for quality and
            training purposes.Job Opportunities:  You may choose to apply for
            employment opportunities at COMPANY through the COMPANY website.  If
            you complete an application for a job at COMPANY, we may collect
            your contact information, job history info and certain other
            information that may be required or allowed under applicable laws to
            screen candidates for employment.  We may share this information
            with other COMPANY subsidiaries and affiliates and vendors and
            suppliers who provide us with candidate search and hiring
            services.The following table provides further information on some of
            the specific types of personal or user data we may collect from you,
            how we use it and with whom we may share it:DATA COLLECTEDPURPOSES
            OF USETHIRD PARTIES WITH WHOM WE MAY SHARE ITFirst and Last
            NameAccount Management, Sales, Marketing & Social Media, Customer
            Service & Support; Job Applications and Employment ScreeningCOMPANY
            subsidiaries and affiliates; Vendors and Suppliers; Marketing
            agencies who handle campaigns on behalf of COMPANYContact
            Information (e.g., phone, email, mailing/billing/shipping
            address)Account Management, Sales, Marketing & Social Media,
            Customer Service & Support; Job Applications and Employment
            ScreeningCOMPANY subsidiaries and affiliates; Vendors and Suppliers;
            Marketing agencies who handle campaigns on behalf of COMPANYPayment
            Information (e.g., credit/debit card) Sales, Customer Service &
            SupportVendors and SuppliersUsername and PasswordAccount Management,
            Sales, Customer Service & SupportVendors and SuppliersFull/Partial
            Date of BirthSales,  Marketing & Social Media, Customer Service &
            Support; Job Applications and Employment ScreeningCOMPANY
            subsidiaries and affiliates; Vendors and Suppliers; Marketing
            agencies who handle campaigns/contests on behalf of COMPANYAnswers
            to Account Security QuestionsAccount Management, Customer Service &
            SupportVendors and SuppliersInternet Protocol (IP) AddressesWeb,
            Network and Product Security; Marketing & Social Media; Customer
            Service & SupportCOMPANY subsidiaries and affiliates; Vendors and
            SuppliersSocial Media Profile InformationMarketing & Social Media,
            Customer Service & SupportVendors and Suppliers; Marketing agencies
            who handle campaigns/contests on behalf of COMPANYEmployment
            Background and Screening InformationJob Applications and Employment
            ScreeningCOMPANY subsidiaries and affiliates; Vendors and
            SuppliersDoes COMPANY use cookies and related technologies on its
            websites?Cookies are small pieces of data that are sent to your
            browser from a web server and stored on your computer.  Websites,
            including COMPANY’s sites, use cookies to help remind us who you are
            when you visit our site; to help you navigate our site during your
            visits; and to save preferences and shopping cart contents for you
            so you will not have to re-enter them.COMPANY may also use cookies
            to store and help track information about you, including for online
            advertising purposes and specifically to determine which
            interest-based ads to display. Where required by applicable law,
            COMPANY will acquire consent from you prior to using certain cookies
            during your COMPANY website experience or will offer you the
            opportunity to choose which types of cookies to enable or disable.  
            To review or change your cookie preferences on our site, please
            click here.To serve and manage cookies, and related technologies
            such as tags and website data analytics tools, COMPANY may use
            products and services hosted by companies such as Google, Facebook
            and Twitter. These services may collect information, such as your IP
            address, sent by your browser or via cookies.The use of such cookies
            is relatively standard. Most browsers are initially set up to accept
            them. However, if you prefer not to store cookies, you can choose
            to:not use our sitesset your browser to notify you when you receive
            a cookieset your browser to refuse to accept cookiesupdate or change
            your cookie preferences through our website tool here.delete our
            cookies after visiting our sitebrowse our site using your browser’s
            anonymous usage setting (e.g., "Incognito" mode in Chrome)You should
            also understand that some features of the COMPANY website might not
            function properly if you do not accept cookies.If you do not know
            how to control or delete cookies or would like to opt-out of
            receiving certain targeted ads based on your browsing history, you
            may wish to visit https://www.networkadvertising.org/choices/,
            https://www.aboutads.info/, or https://www.youronlinechoices.eu/ for
            detailed guidance, including opt-out instructions.  If you would
            like to opt-out of certain third party supported Internet
            advertising and behavioral targeting services, please visit any of
            the following:GoogleFacebookTwitterAdobe Marketing CloudFor
            additional information:
             https://www.consumer.ftc.gov/articles/how-protect-your-privacy-onlineDoes
            COMPANY collect personal data from children?COMPANY’s websites,
            products and services are intended for adults aged 18 and older.
             Typically, if we become aware that we have collected personal data
            from persons aged 17 and under, we will take appropriate steps to
            delete and purge that data.  How long does COMPANY retain the
            personal data it collects?COMPANY intends to retain personal data
            only as long as necessary to complete the purposes of use described
            above in section 2.  When those purposes have been fulfilled, we
            will securely delete personal data as appropriate.  However, we may
            retain your personal data as long as any of the following
            circumstances apply:your COMPANY account or marketing subscription
            is activeto provide you with services or support that you have
            requestedto comply with applicable laws, including for tax and audit
            purposesto enforce COMPANY’s rights, including litigation and debt
            collectionDoes COMPANY sell personal data?While COMPANY may share
            personal data it collects pursuant to the purposes described above
            in section 2, COMPANY does not sell personal data.  If COMPANY did
            decide to sell personal data at any point, we would provide
            appropriate notice and consent mechanisms to individuals as required
            by applicable laws. In addition, please note that if COMPANY or any
            of its businesses or operations were to be sold to another entity at
            any point, that sale could involve the transfer of personal data
            held by COMPANY to the acquiring organization.  In such a
            circumstance, COMPANY would provide appropriate notice and consent
            mechanisms to individuals as required by applicable laws.Does
            COMPANY transfer personal data across borders?COMPANY may collect,
            process, use, retain and transfer personal data across borders in
            order to fulfill our purposes of use as described above in section
            2.  This may include transfers of personal data to countries that
            may not have equivalent privacy or data protection laws to those in
            your own country.  However, regardless of where we transfer personal
            data to, COMPANY takes appropriate steps to ensure that your
            personal data enjoys consistent standards of care.  This includes
            signing contracts between COMPANY affiliates and with our vendors
            and suppliers to make sure that both parties are following
            consistent privacy and security principles, processes and
            protections.For transfers involving European personal data, COMPANY
            uses Standard Contractual Clauses with its partners.  How does
            COMPANY protect personal data?COMPANY believes that privacy and
            security go hand-in-hand.  We use appropriate physical, technical,
            and administrative controls to protect the personal data we are
            responsible for.  That includes encryption and other enhanced
            security measures, where appropriate or required.  We also take
            appropriate steps to make sure that our vendors, suppliers and
            certain other partners adopt consistent standards of protection for
            the personal data that COMPANY is responsible for.   However, it is
            important to note that no technology is guaranteed to be
            invulnerable to threat or attack.  Therefore, please be sure to
            exercise care when using any website or product.  If technology you
            use is configured with privacy or security controls or features,
            please be sure to utilize those.How can I review, correct, amend or
            delete my personal data?In addition, under this privacy statement
            and certain applicable laws, you may submit a request to COMPANY to
            review, correct, amend or to delete your personal data that COMPANY
            has about you.  You may also have the right to request a
            machine-readable copy of your personal data. To submit such a
            request to COMPANY, please contact us at support@usenode.com .
            Please note that we will review, respond to and act upon such
            requests as soon as possible and in accordance with applicable laws.
             We are also required to verify your identity before granting you
            access to your personal data.  If you have an COMPANY account, we
            may verify your identity by requiring you to sign into your account.
            If you do not have an COMPANY account, or an email address on file
            with us, then we may request additional limited information from you
            in order to verify your identity. Please note that if you do not
            have an account with COMPANY, or an email address on file, or if we
            are unable to verify your identity in our records, we may deny your
            request.You may also use an authorized agent to submit a request
            under this section on your behalf. If you choose to have an
            authorized agent submit such a request on your behalf, COMPANY will
            require: (i) You to provide the authorized agent written permission
            to do so; and (ii) your agent to verify their identity directly with
            COMPANY.  COMPANY may deny a request from an agent that does not
            meet these requirements.In addition, you have the right to raise
            questions or complaints with your applicable national data
            protection authority at any time. How can I contact COMPANY?If you
            have any additional questions, complaints or concerns regarding
            privacy at COMPANY. Please feel free to reach us at the following:
             support@usenode.com   TERMS OF USE FOR NODE TECHNOLOGIES, INC. The
            following terms and conditions govern use of all content, services,
            and products (the “Service”) provided by NODE TECHNOLOGIES, INC.
            (“NODE”) and available on the NODE sites (the “Site”). The Service
            is owned and operated by NODE. The Site is intended to be used by
            companies (“Company(s)”) and customers (“Customers(s)” together with
            Companies “User” or “Users”) in connection with the Services.The
            Service is offered subject to your acceptance without modification
            of all of the terms and conditions contained herein and all other
            operating rules, policies, and procedures that may be published from
            time to time on the Site (collectively, the “Agreement”).If you are
            entering into this Agreement on behalf of a company or other legal
            entity, you represent that you have the authority to bind such
            entity, its affiliates, and all users who access the Service through
            your account to this Agreement, in which case the terms “you” or
            “your” shall refer to such entity, its affiliates, and users
            associated with it. If you do not have such authority, or if you do
            not agree with these terms and conditions, you must not accept this
            Agreement and may not use the Service.PLEASE READ THIS AGREEMENT
            CAREFULLY BEFORE ACCESSING OUR SITE OR USING THE SERVICE. BY
            ACCESSING OR USING ANY PART OF THE SITE, YOU AGREE TO BECOME BOUND
            BY THIS AGREEMENT. THESE TERMS INCLUDE A BINDING ARBITRATION CLAUSE
            AND A CLASS ACTION WAIVER. If you do not agree to all the terms and
            conditions of this Agreement, then you may not access the Service.
            If these terms and conditions are considered an offer by NODE,
            acceptance is expressly limited to these terms.NODE AND ITS SITE IS
            A PLATFORM AND IS NOT A PARTY TO ANY SERVICES AGREEMENT OR OTHER
            TRANSACTION BETWEEN USERS OF THE SITE.NODE acts as a venue for Users
            of the Site to view and post services on the Site. NODE is not a
            party to any actual agreement or transaction between Users even
            though we may from time to time provide tools that relate to such
            transaction, such as a tool to enable payment for services. As a
            result, NODE has no control over the accuracy or correctness of the
            content or information provided or used by such Companies and
            Customers. Any part of an actual or potential transaction between a
            Company and a Customer, including the condition, quality, safety of
            the services advertised, the truth or accuracy of the service
            (including the content thereof or any review related thereto), the
            ability of Companies to provide services, or the ability of
            Customers to pay for services are solely the responsibility of each
            User. Separate Agreements. Users acknowledge and agree that you will
            be required to enter into a separate agreement and/or waiver,
            directly between the Company and Customer, prior to purchasing a
            product or service and such agreement and/or waiver may place
            additional restrictions on your product, or service. Any separate
            agreements and/or waivers relating to the products or services are
            under the sole control of any Company and Customer.General Account
            TermsYou must be a human. Accounts registered by “bots” or other
            automated methods are not permitted.Each account may be only used by
            one person and you may only have one account. If it is discovered
            that you have registered multiple accounts, are sharing accounts
            with another individual, or are otherwise accessing the Site through
            an account that is not your own, all accounts affected by such use
            shall be terminated.You are responsible for maintaining the security
            of your account and password. NODE cannot and will not be liable for
            any loss or damage from your failure to comply with this security
            obligation. You are fully responsible for all activities that occur
            under the account and any other actions taken in connection with the
            account. You must immediately notify NODE of any unauthorized uses
            of your account, or any other breaches of security. NODE will not be
            liable for any acts or omissions by you, including any damages of
            any kind incurred as a result of such acts or omissions. You may not
            use the Service for any illegal or unauthorized purpose. You must
            not, in the use of the Service, violate any laws in your
            jurisdiction (including but not limited to copyright or trademark
            laws). No matter what else is said in these Terms or anywhere else
            within the Services, you expressly acknowledge that you have no
            right, title, or interest to or in any account you create through
            our Services, and your account is not your property.By using the
            Site, you warrant and represent that you are at least 18 years of
            age and otherwise legally competent to read, understand and accept
            the provisions of this Agreement. If you are under 18 years of age,
            you must not use any part of the Site, create an account, or submit
            any personal information to NODE through the Site. NODE may remove
            Content that violates the Agreement at its sole discretion. Removing
            Content, or terminating an account are not actions NODE take
            lightly, and we may take a while to investigate and determine if
            such actions are warranted. It is at NODE’s sole discretion whether
            to discuss the reasons for taking action against any Content or
            account.CommunicationBy using this Site and our services you give
            NODE your express permission to contact you via email, messaging, or
            other electronic or non-electronic forms of communication for all
            purposes including distribution of marketing and promotional
            materials.We provide interactive services on our Site, including,
            without limitation chat rooms and bulletin boards. We will take
            reasonable endeavours to assess any possible risks for Users from
            third parties when they use any interactive service provided on our
            Site, and we will decide in each case whether it is appropriate to
            use moderation of the relevant Service (including what kind of
            moderation to use) in the light of those risks. However, we are
            under no obligation to oversee, monitor or moderate any interactive
            service we provide on our Site, and we expressly exclude our
            liability for any loss or damage arising from the use of any
            interactive service by a user in contravention of our content
            standards, whether the Service is moderated or not. Should a
            difficulty arise, the user should contact us by emailing
            support@usenode.com immediately.ContentIf you make (or allow any
            third party to make) material available through the Site (any such
            material, “Content”), you are entirely responsible for the content
            of, and any harm resulting from, that Content. That is the case
            regardless of whether the Content in question constitutes text,
            graphics, an audio file, or computer software.A. By making Content
            available, you represent and warrant that:the downloading, copying,
            and use of the Content will not infringe the proprietary rights,
            including but not limited to the copyright, patent, trademark, or
            trade secret rights, of any third party;if your employer has rights
            to intellectual property you create, you have either (i) received
            permission from your employer to post or make available the Content,
            including but not limited to any software, or (ii) secured from your
            employer a waiver as to all rights in or to the Content;you have
            fully complied with any third-party licenses relating to the
            Content, and have done all things necessary to successfully pass
            through to end users any required terms;the Content does not contain
            or install any viruses, worms, malware, trojan horses, or other
            harmful or destructive content;the Content is not spam, is not
            machine- or randomly-generated, and does not contain unethical or
            unwanted commercial content designed to drive traffic to third party
            sites or boost the search engine rankings of third party sites, or
            to further unlawful acts (such as phishing) or mislead recipients as
            to the source of the material (such as spoofing);the Content is not
            pornographic, does not contain threats or incite violence, and does
            not violate the privacy or publicity rights of any third party;the
            Content is not getting advertised via unwanted electronic messages
            such as spam links on newsgroups, email lists, other groups and web
            sites, and similar unsolicited promotional methods;the Content is
            not named in a manner that misleads your readers into thinking that
            you are another person or company; andyou have, in the case of
            Content that includes computer code, accurately categorized and/or
            described the type, nature, uses, and effects of the materials,
            whether requested to do so by NODE or otherwise.B. Without limiting
            any of those representations or warranties, NODE has the right
            (though not the obligation) to, in NODE’s sole discretion:refuse or
            remove any content that, in NODE’s reasonable opinion, violates any
            NODE policy or is in any way harmful or objectionable, orterminate
            or deny access to and use of the Service to any individual or entity
            for any reason. NODE will have no obligation to provide a refund of
            any amounts previously paid.As a User, you may deactivate your
            account at any time. Personally identifying information such as your
            name, username, and profile photo will no longer be associated with
            Content you have posted. Our Fees You agree to pay NODE the fees
            indicated for the Service. Refunds All of the fees are not
            non-refundable. Requests for refunds will be reviewed and determined
            on a case by case basis. When a user makes a payment through a
            module external to the partner company. A fee of 5% of the total
            amount of the transaction (maximum 2.51$ inc. taxes) is charged to
            the paying user. If the paying user makes a payment through an
            external widget or through Node's mobile application, he will be
            automatically charged with an independent transaction. NODE reserves
            the right, in its reasonable discretion, to refuse to refund
            fees.PaymentsIn order to use certain Site Services, you must provide
            account information for at least one valid payment method.You hereby
            authorize NODE, to run credit card authorizations on all credit
            cards provided by you, to store credit card and banking or other
            financial details as your method of payment consistent with our
            Customer Privacy Statement, and to charge your credit card (or any
            other payment method) for the Fees and any other amounts owed under
            the Agreement. To the extent permitted by applicable law and subject
            to our Customer Privacy Statement, you acknowledge and agree that we
            may use certain third-party vendors and service providers to process
            payments and manage your payment method information.By providing
            payment method information through the Site and authorizing payments
            with the payment method, you represents, warrants, and covenants
            that: (a) you are legally authorized to provide such information;
            (b) you are legally authorized to make payments using the payment
            method(s); (c) if you are an employee or agent of a company or
            person that owns the payment method, you are authorized by the
            company or person to use the payment method to make payments; and
            (d) such actions do not violate the terms and conditions applicable
            to your use of such payment method(s) or applicable law.Copyright
            PolicyNODE respects copyright law and expects its users to do the
            same. It is NODE’s policy to terminate in appropriate circumstances
            users or other account holders who repeatedly infringe or are
            believed to be repeatedly infringing the rights of copyright
            holders.NODE Intellectual Property OwnershipThe Services contain
            proprietary materials such as logos, text, software, photos, video,
            graphics, music and sound. NODE is the owner or licensee of all such
            proprietary material and all intellectual property rights therein,
            including without limitation, copyrights and trademarks. In using
            the Services, you agree not to upload, download, distribute, or
            reproduce in any way any such proprietary materials without
            obtaining NODE’s prior consent. BySoftware License Terms We Own the
            SoftwareNode’s systems and software (“Software”) (including any
            releases, revisions, updates or enhancements to the Software) and
            any documentation that accompanies or is made available in
            connection with Software (including any subscription or purchase
            information, product packaging) (the “Documentation”), is owned by
            NODE or its licensors. This includes all Intellectual Property
            Rights in and to the Software and Documentation. Any Software that
            NODE provides to you is licensed, not sold to you, and NODE reserves
            all rights to the Software not expressly granted in these Software
            License Terms.So long as you comply with the terms and conditions of
            the Agreement, NODE grants to you a limited non-exclusive,
            non-transferable license, with no right to sublicense, to download
            and install a copy of the Software on a mobile device, computer or
            tablet that you own or control and to run such copy of the Software
            solely for purposes of accessing and using the Services where the
            corresponding Services are available for your use during the
            applicable subscription period.You may not: (i) copy, modify or
            create derivative works based on the Software; (ii) distribute,
            transfer, sublicense, lease, lend or rent the Software to any third
            party; (iii) reverse engineer, decompile or disassemble the
            Software; or (iv) make the functionality of the Software available
            to third parties, except and only to the extent that applicable law
            expressly permits.These Terms allow you to install only one copy of
            the Software for use on a single computer, mobile device or tablet,
            unless your subscription to the Services expressly permits you to
            use Software on more than one device. You may make one copy of the
            Software for back-up or archival purposes or copy the Software onto
            the hard disk of your device and retain the original for back-up or
            archival purposes only.Upon expiration or any termination of these
            Terms, you must stop using and destroy all copies of the Software
            and the Documentation in your possession.There may be technological
            measures in the Software that are designed to prevent unlicensed or
            illegal use of the Software. You agree that NODE may use these
            measures to protect NODE against Software piracy (e.g. the software
            may contain enforcement technology that limits the ability to
            install and uninstall the Software on a device to not more than a
            finite number of times for a finite number of devices). You may need
            to activate these technological measures. If so, the Software will
            only operate for a finite period prior to Software activation by
            you. During activation, you may be required to provide a unique
            activation code accompanying the Software and device configuration
            in the form of an alphanumeric code over the internet to verify the
            authenticity of the Software. If you do not complete the activation
            within the finite period or as prompted by the Software, the
            Software will cease to function until activation is complete; at
            which time the Software functionality will be restored. If you are
            not able to activate the Software during the activation process, you
            may contact NODE using the information provided during activation or
            by the provider of the Software.ChangesWe reserve the right to
            modify the Agreement at any time and modified terms are effective
            upon posting to the Site. We will make reasonable efforts to inform
            you of these changes via email or through the Service. Your
            continued use of or access to the Service following the posting of
            any changes to this Agreement constitutes acceptance of those
            changes. NODE may also, in the future, offer new services and/or
            features including the release of new tools and resources. Such new
            features and/or services shall be subject to the terms and
            conditions of this Agreement.DataUsers may request data related to
            their personal account and group(s) respectively. NODE has the right
            to refuse repetitive or technically difficult requests. For
            information about how we collect and share user information please
            refer to our Customer Privacy Statement.Disclaimer of WarrantiesTHE
            SERVICE IS PROVIDED “AS IS” AND "AS AVAILABLE". NODE AND ITS
            OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, SUBSIDIARIES, AFFILIATES,
            LICENSORS AND SUPPLIERS HEREBY EXPRESSLY DISCLAIM ALL WARRANTIES OF
            ANY KIND, EXPRESS OR IMPLIED, INCLUDING, WITHOUT LIMITATION, THE
            IMPLIED WARRANTIES OF TITLE, MERCHANTABILITY, NON-INFRINGEMENT, AND
            FITNESS FOR A PARTICULAR PURPOSE. NEITHER NODENOR ITS OFFICERS,
            DIRECTORS, EMPLOYEES, AGENTS, SUBSIDIARIES, AFFILIATES, LICENSORS
            NOR SUPPLIERS WARRANT THAT THE OPERATION OF THE SERVICE WILL BE
            UNINTERRUPTED, ERROR FREE OR WITHOUT BREACHES OF SECURITY.NODE, ITS
            OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, SUBSIDIARIES, AFFILIATES,
            AND ITS LICENSORS DO NOT REPRESENT OR WARRANT THAT:THE INFORMATION
            PROVIDED ON SITE IS TRUE OR CORRECT,YOUR USE OF THE SERVICES WILL
            MEET YOUR REQUIREMENTS OR EXPECTATIONS,YOUR USE OF THE SERVICES WILL
            BE UNINTERRUPTED, TIMELY, SECURE OR FREE FROM ERROR,ANY INFORMATION
            OBTAINED BY YOU AS A RESULT OF YOUR USE OF THE SERVICES WILL BE
            ACCURATE OR RELIABLE, ORTHAT DEFECTS IN THE OPERATION OR
            FUNCTIONALITY OF ANY SOFTWARE PROVIDED TO YOU AS PART OF THE
            SERVICES WILL BE CORRECTED.Limitation of LiabilityIN NO EVENT WILL
            NODE ITS OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, SUBSIDIARIES OR
            AFFILIATES BE LIABLE TO ANY PARTY FOR:ANY DIRECT, INDIRECT,
            INCIDENTAL, CONSEQUENTIAL, SPECIAL, EXEMPLARY, OR PUNITIVE, DAMAGES
            ARISING OUT OF THE USE, AVAILABILITY OR UNAVAILABILITY OF THE
            SERVICES (INCLUDING BUT NOT LIMITED TO THE UNAVAILABILITY OR CHANGE
            IN ADVERTISED SERVICES) OR ANY OTHER SERVICES OR GOODS OBTAINED
            THROUGH USE OF ANY OF THE FOREGOING, OR ANY DATA TRANSMITTED THROUGH
            THE SERVICE, EVEN IF NODE HAS BEEN ADVISED OF THE POSSIBILITY OF
            SUCH DAMAGES; ANDANY LOSS OR DAMAGE WHICH MAY BE INCURRED BY YOU,
            INCLUDING BUT NOT LIMITED TO LOSS OR DAMAGE AS A RESULT OF:ANY
            RELIANCE PLACED BY YOU ON THE COMPLETENESS, ACCURACY OR EXISTENCE OF
            ANY ADVERTISING, OR AS A RESULT OF ANY RELATIONSHIP OR TRANSACTION
            BETWEEN YOU AND ANY ADVERTISER OR SPONSOR WHOSE ADVERTISING APPEARS
            ON THE SERVICES;ANY CHANGES WHICH NOD EMAY MAKE TO THE SERVICES, OR
            FOR ANY PERMANENT OR TEMPORARY CESSATION IN THE PROVISION OF THE
            SERVICES (OR ANY FEATURES WITHIN THE SERVICES);YOUR FAILURE TO
            PROVIDE NODE WITH ACCURATE INFORMATION;YOUR FAILURE TO KEEP YOUR
            PASSWORD OR ACCOUNT DETAILS SECURE AND CONFIDENTIAL.ANY BODILY
            INJURY, DEATH, OR PROPERTY DAMAGE THAT MAY OCCUR AS THE RESULT OF
            SERVICES. ‍NOTWITHSTANDING THE TERMS, IN NO EVENT SHALL NODE BE HELD
            LIABLE, FOR ANY AMOUNTS IN EXCESS OF (IN THE AGGREGATE) ONE HUNDRED
            U.S. DOLLARS ($100.00).  NODE SHALL HAVE NO LIABILITY FOR ANY
            FAILURE OR DELAY DUE TO MATTERS BEYOND THEIR REASONABLE CONTROL. THE
            FOREGOING SHALL NOT APPLY TO THE EXTENT PROHIBITED BY APPLICABLE
            LAW.IndemnificationYou agree to indemnify, release, defend and hold
            harmless NODE and its directors, officers, agents and employees
            (collectively, the “NODE parties”) from any claims, causes of
            action, demands, recoveries, losses, damages (actual and
            consequential), fines, penalties and other costs or expenses, of any
            kind or nature, including but not limited to reasonable legal and
            accounting fees (collectively, the “claims”), known and unknown,
            arising out of or in any way connected with such disputes,
            including, without limitation, disputes arising over breach of this
            agreement, breach of any separate agreement or transaction, and/or
            the substitution of units. Further, you hereby agree to indemnify,
            release, defend and hold harmless the NODE parties from any claims
            brought as a result of your (1) breach of the terms, (2) violation
            of any law or the rights of a third party, and (3) use of this Site
            and the Services. Disputes ResolutionThis Agreement constitutes the
            entire agreement between NODEcand you concerning the subject matter
            hereof, and they may only be modified by a written amendment signed
            by an authorized agent/employee of COMPANY, or by the posting by
            NODEcof a revised version. Any and all disputes arising of this
            Agreement, termination, or our relationship with you shall be
            determined by applying laws of the State of Delaware. If any part of
            this Agreement is held invalid or unenforceable, that part will be
            struck, and the remaining portions will remain in full force and
            effect. A waiver by either party of any term or condition of this
            Agreement or any breach thereof, in any one instance, will not waive
            such term or condition or any subsequent breach thereof. You may not
            assign your rights under this Agreement without written consent from
            NODE; NODE may assign its rights under this Agreement without
            condition. This Agreement will be binding upon and will inure to the
            benefit of the parties, their successors and permitted
            assigns.ARBITRATION Dispute resolution and arbitrationBy using this
            Site, you agree that any and all disputes, claims or controversies
            that you may have against NODE arising out of or relating to or
            connected in any way to (i) your use of this Site (ii) any services
            obtained from or provided by NODE or (iii) this Agreement (including
            the interpretation and scope of this clause and the arbitrability of
            the dispute), shall be resolved exclusively by mandatory, binding
            arbitration initiated through and administered by the American
            Arbitration Association ("AAA"). You further agree that arbitration
            will be conducted by a single arbitrator pursuant to the applicable
            Rules and Procedures established by AAA, and that any arbitration
            proceeding, if necessary, will be held in Montréal, Canada or at
            such other location as may be mutually agreed upon by NODE and you.
            Arbitration will be subject to the Federal Arbitration Act and not
            any state arbitration law. The arbitrator shall apply Montréal,
            Canada law consistent with the Federal Arbitration Act, and shall
            honor claims of privilege recognized at law. In order to initiate
            arbitration with the AAA, you may be responsible for paying a filing
            fee to the AAA, however, in the event you are able to demonstrate
            that the costs of arbitration will be prohibitive as compared to the
            costs of litigation, NODE will reimburse as much of your filing and
            hearing fees in connection with the arbitration as the arbitrator
            deems necessary to prevent the arbitration from being
            cost-prohibitive. There will be no right or authority for any claims
            to be arbitrated on a class action or representative basis. YOU
            UNDERSTAND AND AGREE THAT, BY ACCEPTING THESE TERMS AND CONDITIONS,
            YOU AND NODE ARE EACH WAIVING THE RIGHT TO A TRIAL BY JURY OR TO
            PARTICIPATE IN A CLASS ACTION WITH RESPECT TO THE CLAIMS COVERED BY
            THIS MANDATORY ARBITRATION PROVISION. You are thus giving up your
            right to go to court to assert or defend your rights. Your rights
            will be determined by a neutral arbitrator, and not a judge or
            jury.All claims you bring against NODE must be resolved in
            accordance with this arbitration provision. All claims filed or
            brought by you contrary to this provision will be considered
            improperly filed and void. Should you file a claim contrary to this
            arbitration provision, NODE will notify you in writing of the
            improperly filed claim, and you must promptly withdraw the claim.
             If you fail to promptly withdraw the claim after receiving written
            notice from NODE, NODE may recover its reasonable attorneys’ fees
            and costs incurred to enforce this arbitration provision.Notice;
            ProcessA party who intends to seek arbitration must first send a
            written notice of the dispute to the other, by certified mail,
            Federal Express, UPS, or Express Mail (signature required), or in
            the event that we do not have a physical address on file for you, by
            electronic mail ("Notice"). NODE's address for Notice is:
            support@usenode.com.The Notice must (1) describe the nature and
            basis of the claim or dispute; and (2) set forth the specific relief
            sought ("Demand"). We agree to use good faith efforts to resolve the
            claim directly, but if we do not reach an agreement to do so within
            30 days after the Notice is received, you or NODE may commence an
            arbitration proceeding. During the arbitration, the amount of any
            settlement offer made by you or NODE shall not be disclosed to the
            arbitrator until after the arbitrator makes a final decision and
            award, if any. All documents and information disclosed in the course
            of the arbitration shall be kept strictly confidential by the
            recipient and shall not be used by the recipient for any purpose
            other than for purposes of the arbitration or the enforcement of the
            arbitrator’s decision and award and shall not be disclosed except in
            confidence to persons who have a need to know for such purposes or
            as required by applicable law.EnforceabilityIf any part of this
            arbitration provision is deemed to be invalid, unenforceable or
            illegal, or otherwise conflicts with the Rules and Procedures
            established by AAA, then the balance of this arbitration provision
            shall remain in effect and shall be construed in accordance with its
            terms as if the invalid, unenforceable, illegal or conflicting
            provision was not contained herein.Miscellaneous General Compliance
            with LawsYou shall comply with all applicable laws, statutes,
            ordinances and regulations regarding your use of the
            Services.HeadingsHeadings are for reference purposes only and in no
            way define, limit, construe or describe the scope or extent of such
            section.Entire Agreement This Agreement constitutes the entire
            agreement between NODE and you concerning the subject matter hereof,
            and they may only be modified by a written amendment signed by an
            authorized agent/employee of NODE, or by the posting by NODE of a
            revised version. Governing LawThe terms of this Agreement shall be
            construed in accordance with the substantive laws of the State of
            Delaware, United States of America, without giving effect to the
            principles of conflict or choice of law of such state. The original
            form of this Agreement has been written in English. The parties
            hereto waive any statute, law, or regulation that might provide an
            alternative law or forum or might require this Agreement to be
            written in any language other than English. This Agreement expressly
            excludes the United Nations Convention on Contracts for the
            International Sale of Goods.SeverabilityIf any part of this
            Agreement is held invalid or unenforceable, that part will be
            struck, and the remaining portions will remain in full force and
            effect.WaiverA waiver by either party of any term or condition of
            this Agreement or any breach thereof, in any one instance, will not
            waive such term or condition or any subsequent breach thereof.
            Assignment You may not assign your rights under this Agreement
            without written consent from NODE; NODE may assign its rights under
            this Agreement without condition. This Agreement will be binding
            upon and will inure to the benefit of the parties, their successors
            and permitted assigns.TerminationNODE may immediately issue a
            warning, temporarily suspend, indefinitely suspend or terminate your
            use of all or any portion of the Services if you breach the Terms,
            or at any time or for any reason, at the sole discretion of NODE.No
            RelationshipNo joint venture, partnership, employment, or agency
            relationship exist between you, NODE or any third party provider as
            a result of this Agreement or use of the Service. Force Majeure NODE
            shall not be liable for any delay or failure to perform in
            connection with any Services, Service or in the performance of any
            obligation hereunder, if such delay or failure is due to or in any
            manner caused by acts of God, rebellion, riots, hijacking,
            insurrection, civil commotion, strikes or labor disputes, fires,
            floods, laws, regulations, acts, demands or and orders of any
            government or agency, or any other cause which is beyond the control
            of NODE. NODE is hereby released by you from any claim or demand for
            any direct or consequential damages arising out of failure to
            perform as a result of a force majeure event whether or not herein
            enumerated or other event referenced above.Contacting COMPANY If you
            have any questions about these Terms of Service, please contact NODE
            at support@usenode.com.          
          </Typography>
        </Box>
        <Box marginBottom="25px">
          <Typography marginTop="12px" variant="p">
            CE CONTRAT EST VALIDE POUR LES CONSOMMATEURS ET LES ENTREPRISES
            PARTICIPANTES - THIS CONTRACT IS VALID FOR CONSUMERS AND
            PARTICIPATING COMPANIESNODE TECHNOLOGIES, INC. CUSTOMER PRIVACY
            STATEMENTNODE TECHNOLOGIES, INC. DÉCLARATION DE CONFIDENTIALITÉ DES
            CLIENTS NODE TECHNOLOGIES, INC. ("L'ENTREPRISE") accorde une grande
            importance à votre confidentialité.  Pour en savoir plus sur les
            données personnelles et d'utilisateur que l'ENTREPRISE recueille,
            utilise, conserve et partage, sur la façon dont nous protégeons vos
            données personnelles et sur les choix et moyens de contrôle dont
            vous disposez sur vos données personnelles, veuillez lire cette
            déclaration dans son intégralité.Cette déclaration de
            confidentialité a été mise à jour pour la dernière fois le 31
            janvier 2025.  Si nous apportons des modifications importantes à
            cette déclaration de confidentialité, nous publierons un avis sur
            notre site Web et/ou nous contacterons nos clients comme il convient
            ou comme l'exige la loi applicable.  Table des matièresQu'est-ce que
            cette déclaration de confidentialité couvre ? Quelles sont les
            données personnelles, d'utilisateur et de produit que la COMPAGNIE
            recueille et comment la COMPAGNIE utilise et partage les données
            personnelles qu'elle recueille ? Comment l'ENTREPRISE protège-t-elle
            les données personnelles ? Comment puis-je réviser, corriger,
            modifier ou supprimer mes données personnelles ? Comment puis-je
            contacter l'ENTREPRISE ? Que couvre cette déclaration de
            confidentialité ? Cette déclaration décrit les pratiques de
            l'ENTREPRISE en matière de protection de la vie privée de ses
            clients pour ses sites web mondiaux, ses applications, ses services,
            ses activités de vente et de marketing, ses services à la clientèle
            et ses fonctions de soutien, entre autres.  Veuillez également noter
            que certains sites Web de l'ENTREPRISE ou certaines expériences
            logicielles peuvent contenir des liens vers des sites Web ou des
            services tiers.  Dans la plupart des cas, ces ressources tierces
            sont soumises aux pratiques et politiques de confidentialité de ces
            tiers et non de l'ENTREPRISE.Quelles sont les données personnelles,
            les données sur les utilisateurs et les données sur les produits que
            l'ENTREPRISE recueille et comment l'ENTREPRISE utilise-t-elle et
            partage-t-elle les données personnelles qu'elle recueille ?
            L'ENTREPRISE peut recueillir certaines catégories de données à votre
            sujet lorsque vous utilisez nos sites Web ; utilisez nos services ;
            recevez nos communications marketing ; interagissez avec notre
            service à la clientèle et nos équipes de soutien ; et dans d'autres
            contextes.  Les données que nous recueillons peuvent être
            catégorisées comme suit :Données personnelles :  Il s'agit de
            données identifiables individuellement que vous pouvez choisir de
            nous fournir.  Il peut s'agir d'informations de base telles que
            votre adresse électronique et votre numéro de téléphone, ou
            d'informations plus sensibles telles que votre date de naissance
            complète ou vos informations de paiement.Données utilisateur :  Il
            s'agit des données que nous recueillons auprès des utilisateurs de
            nos services.  Les données utilisateur peuvent inclure des données
            personnelles telles que votre identifiant unique de l'entreprise ou
            le nom d'utilisateur et le mot de passe de votre compte, mais
            parfois ces données utilisateur sont anonymes ou "pseudonymes",
            c'est-à-dire certaines données utilisateur qui pourraient être
            rendues identifiables si elles étaient associées à des données
            personnelles.Données de localisation : Il s'agit des données que
            nous recueillons et qui nous aident à déterminer un emplacement en
            fonction de votre adresse IP afin de personnaliser notre Service et
            pour d'autres utilisations conformes à la présente Déclaration de
            confidentialité.L'ENTREPRISE a diverses utilisations de vos données
            personnelles et d'utilisateur que vous nous fournissez.  Voici les
            principaux contextes dans lesquels nous pouvons utiliser, conserver
            et partager vos données personnelles et d'utilisateur :Sites Web et
            gestion des comptes :  Le plus souvent, vous pouvez naviguer sur nos
            sites Web sans nous fournir de données personnelles.  Toutefois, si
            vous choisissez d'établir un compte d'utilisateur avec la SOCIÉTÉ,
            de faire du commerce électronique, de vous inscrire à des
            communications marketing, d'interagir avec nos équipes de service à
            la clientèle ou de participer à un forum sur notre site Web, nous
            devrons probablement recueillir certaines données personnelles ou
            d'utilisateur auprès de vous.  En outre, nos serveurs web collectent
            automatiquement certaines données par défaut, telles que les
            adresses IP et autres journaux d'activité.  Ce type de données est
            utilisé à des fins de sécurité et d'amélioration du site.  La
            plupart de ces données ne sont pas facilement identifiables et sont
            généralement conservées de manière anonyme.  Afin de maintenir et
            d'améliorer nos sites web, la COMPAGNIE utilise des partenaires,
            vendeurs et fournisseurs tiers pour l'hébergement, la gestion du
            contenu et la sécurité : Si vous décidez d'acheter un service de la
            SOCIÉTÉ, nous devrons recueillir certaines données personnelles
            auprès de vous, y compris des informations liées au paiement.
             Généralement, nous faisons appel à des partenaires, vendeurs et
            fournisseurs tiers, tels que des sociétés de traitement des
            paiements lors de nos ventes.Marketing et médias sociaux :  Vous
            pouvez choisir de recevoir des communications marketing de la
            COMPAGNIE, de participer à un événement/contest/promotion avec nous,
            ou de vous connecter avec la COMPAGNIE via les médias sociaux.  Si
            vous le faites, nous collecterons certaines données personnelles
            vous concernant, telles que vos coordonnées, vos informations de
            profil sur les médias sociaux et, afin de déterminer votre
            éligibilité à un concours ou une promotion, vos dates de naissance
            complètes ou partielles.  L'ENTREPRISE peut partager vos données
            personnelles avec nos agences de marketing et nos partenaires pour
            mener à bien nos campagnes de marketing, nos concours et nos
            promotions.  Si vous souhaitez vous désabonner de notre marketing,
            veuillez suivre le lien d'exclusion dans les communications que vous
            recevez de notre part ; mettez à jour vos préférences de contact
            dans les paramètres de votre compte de la SOCIÉTÉ ; ou cliquez
            ici.Enregistrement du produit :  Si vous utilisez les services de la
            SOCIÉTÉ, vous pouvez choisir d'établir un compte utilisateur de la
            SOCIÉTÉ. Le profil d'un compte utilisateur de la SOCIÉTÉ peut
            inclure votre nom d'utilisateur, votre mot de passe, vos paramètres,
            vos préférences, vos informations de contact, vos informations
            d'identification d'appareil et des données connexes.  L'ENTREPRISE
            peut partager ces informations avec d'autres filiales et sociétés
            affiliées de l'ENTREPRISE ainsi qu'avec des vendeurs et
            fournisseurs, tels que des partenaires d'hébergement tiers.
             Certains paramètres de produits de l'ENTREPRISE, les informations
            sur les préférences, l'historique des applications et les
            informations de localisation peuvent être utilisés par les équipes
            de développement et d'amélioration des produits et du service à la
            clientèle de l'ENTREPRISE si vous choisissez d'activer des services
            de soutien à la clientèle améliorés.  Service et soutien à la
            clientèle :  Si vous choisissez d'interagir avec le service à la
            clientèle et le soutien de la SOCIÉTÉ - que ce soit par
            l'intermédiaire de notre site Web, des médias sociaux, du
            clavardage, du courriel ou du téléphone - les équipes du service à
            la clientèle de la SOCIÉTÉ (dont certaines travaillent pour des
            vendeurs et des fournisseurs externes de la SOCIÉTÉ) peuvent avoir
            accès aux renseignements sur votre compte, aux renseignements sur
            les produits, aux coordonnées et aux renseignements sur le paiement.
             Vous pouvez également être amené à répondre à certaines questions
            de sécurité pour vérifier votre identité et votre appel ou session
            avec le service clientèle de la SOCIÉTÉ peut être enregistré à des
            fins de qualité et de formation.Opportunités d'emploi :  Vous pouvez
            choisir de postuler à des offres d'emploi au sein de la SOCIÉTÉ par
            le biais du site Web de la SOCIÉTÉ.  Si vous remplissez une demande
            d'emploi à la SOCIÉTÉ, nous pouvons recueillir vos coordonnées, vos
            antécédents professionnels et certains autres renseignements qui
            peuvent être requis ou autorisés en vertu des lois applicables pour
            sélectionner les candidats à l'emploi.  Nous pouvons partager ces
            informations avec d'autres filiales et sociétés affiliées de
            l'ENTREPRISE ainsi qu'avec des vendeurs et fournisseurs qui nous
            fournissent des services de recherche et d'embauche de candidats. Le
            tableau suivant fournit de plus amples informations sur certains
            types spécifiques de données personnelles ou d'utilisateur que nous
            pouvons collecter auprès de vous, sur la manière dont nous les
            utilisons et sur les personnes avec lesquelles nous pouvons les
            partager :DONNÉES COLLECTEES FINS D'UTILISATION PERSONNES TIERCES
            AVEC LESQUELLES NOUS POUVONS LES PARTAGERPrénom et nom de
            familleGestion des comptes, ventes, marketing et médias sociaux,
            service et soutien à la clientèle ; demandes d'emploi et sélection
            des candidatsFiliales et sociétés affiliées de l'ENTREPRISE ;
            vendeurs et fournisseurs ; agences de marketing qui gèrent des
            campagnes au nom de l'ENTREPRISE, téléphone, courriel, adresse
            postale/de facturation/d'expédition)Gestion des comptes, ventes,
            marketing et médias sociaux, service et soutien à la clientèle ;
            demandes d'emploi et présélection des emploisFiliales et sociétés
            affiliées de la SOCIÉTÉ ; vendeurs et fournisseurs ; agences de
            marketing qui gèrent des campagnes au nom de la SOCIÉTÉInformations
            de paiement (p. ex, carte de crédit/débit) Ventes, service à la
            clientèle et soutienVendeurs et fournisseursNom d'utilisateur et mot
            de passeGestion du compte, ventes, service à la clientèle et
            soutienVendeurs et fournisseursDate de naissance
            complète/partielleVentes, marketing et médias sociaux, service à la
            clientèle et soutien ; demandes d'emploi et présélection des
            emploisFiliales et sociétés affiliées de la SOCIÉTÉ ; Vendeurs et
            fournisseurs ; agences de marketing qui gèrent des
            campagnes/concours au nom de la SOCIÉTÉRéponses aux questions de
            sécurité du compteGestion du compte, service et soutien à la
            clientèleFournisseurs et fournisseursAdresses de protocole Internet
            (IP) Sécurité du Web, des réseaux et des produits ; Marketing et
            médias sociaux ; service et soutien à la clientèleFiliales et
            sociétés affiliées de la SOCIÉTÉ ; vendeurs et
            fournisseursInformation sur le profil des médias sociauxMarketing et
            médias sociaux, service et soutien à la clientèleVendeurs et
            fournisseurs ; agences de marketing qui gèrent des
            campagnes/concours au nom de la SOCIÉTÉInformation sur les
            antécédents et le filtrage en matière d'emploiDemandes d'emploi et
            filtrage en matière d'emploiFiliales et sociétés affiliées de la
            SOCIÉTÉ ; vendeurs et fournisseursLa SOCIÉTÉ utilise-t-elle des
            témoins et des technologies connexes sur ses sites Web ? Les cookies
            sont de petits morceaux de données qui sont envoyés à votre
            navigateur à partir d'un serveur web et stockés sur votre
            ordinateur.  Les sites Web, y compris les sites de la COMPAGNIE,
            utilisent des témoins pour nous rappeler qui vous êtes lorsque vous
            visitez notre site ; pour vous aider à naviguer sur notre site au
            cours de vos visites ; et pour sauvegarder vos préférences et le
            contenu de votre panier d'achat afin que vous n'ayez pas à les
            entrer de nouveau.La COMPAGNIE peut également utiliser des témoins
            pour stocker et aider à suivre l'information vous concernant, y
            compris à des fins de publicité en ligne et spécifiquement pour
            déterminer quelles annonces basées sur les intérêts à afficher.
            Lorsque la loi applicable l'exige, la COMPAGNIE obtiendra votre
            consentement avant d'utiliser certains témoins pendant votre
            expérience sur le site Web de la COMPAGNIE ou vous offrira la
            possibilité de choisir les types de témoins à activer ou à
            désactiver.   Pour revoir ou modifier vos préférences en matière de
            cookies sur notre site, veuillez cliquer ici.Pour servir et gérer
            les cookies, et les technologies connexes telles que les balises et
            les outils d'analyse de données de sites Web, la COMPAGNIE peut
            utiliser des produits et services hébergés par des sociétés telles
            que Google, Facebook et Twitter. Ces services peuvent recueillir des
            informations, telles que votre adresse IP, envoyées par votre
            navigateur ou via des cookies.L'utilisation de ces cookies est
            relativement standard. La plupart des navigateurs sont initialement
            configurés pour les accepter. Toutefois, si vous préférez ne pas
            enregistrer de cookies, vous pouvez choisir de :ne pas utiliser
            notre siterégler votre navigateur pour qu'il vous avertisse lorsque
            vous recevez un cookierégler votre navigateur pour qu'il refuse
            d'accepter les cookiesmettre à jour ou modifier vos préférences en
            matière de cookies grâce à l'outil de notre site web ici.supprimer
            nos cookies après avoir visité notre sitenaviguer sur notre site en
            utilisant le paramètre d'utilisation anonyme de votre navigateur
            (par ex, "Incognito" mode dans Chrome)Vous devez également
            comprendre que certaines fonctionnalités du site Web de la SOCIÉTÉ
            peuvent ne pas fonctionner correctement si vous n'acceptez pas les
            cookies.Si vous ne savez pas comment contrôler ou supprimer les
            cookies ou si vous souhaitez refuser de recevoir certaines
            publicités ciblées basées sur votre historique de navigation,  Si
            vous ne savez pas comment contrôler ou supprimer les cookies ou si
            vous souhaitez refuser de recevoir certaines publicités ciblées
            basées sur votre historique de navigation, vous pouvez consulter
            https://www.networkadvertising.org/choices/,
            https://www.aboutads.info/ ou https://www.youronlinechoices.eu/ pour
            obtenir des conseils détaillés, y compris des instructions de refus.
             Si vous souhaitez vous retirer de certains services de publicité
            sur Internet et de ciblage comportemental pris en charge par des
            tiers, veuillez visiter l'un des sites suivants
            :GoogleFacebookTwitterAdobe Marketing CloudPour des informations
            supplémentaires :
            https://www.consumer.ftc.gov/articles/how-protect-your-privacy-onlineDoes
            La COMPAGNIE recueille des données personnelles auprès d'enfants ?
            Les sites Web, produits et services de la COMPAGNIE sont destinés
            aux adultes âgés de 18 ans et plus.  Généralement, si nous nous
            rendons compte que nous avons recueilli des données personnelles de
            personnes âgées de 17 ans et moins, nous prendrons les mesures
            appropriées pour supprimer et purger ces données.  Combien de temps
            la COMPAGNIE conserve-t-elle les données personnelles qu'elle
            recueille ? La COMPAGNIE a l'intention de conserver les données
            personnelles aussi longtemps que nécessaire pour atteindre les
            objectifs d'utilisation décrits ci-dessus dans la section 2.
             Lorsque ces objectifs auront été atteints, nous supprimerons les
            données personnelles de façon sécuritaire, comme il se doit.
             Cependant, nous pouvons conserver vos données personnelles aussi
            longtemps que l'une des circonstances suivantes s'applique :votre
            compte de la COMPAGNIE ou votre abonnement de marketing est actif
            pour vous fournir les services ou le soutien que vous avez demandé
            pour nous conformer aux lois applicables, y compris à des fins
            fiscales et de vérification pour faire valoir les droits de la
            COMPAGNIE, y compris les litiges et le recouvrement de dettesLa
            COMPAGNIE vend-elle des données personnelles ?  Si la COMPAGNIE
            décidait de vendre des données personnelles à un moment donné, nous
            fournirions un avis approprié et des mécanismes de consentement aux
            individus tel que requis par les lois applicables. De plus, veuillez
            noter que si la COMPAGNIE ou l'une de ses entreprises ou opérations
            devait être vendue à une autre entité à un moment donné, cette vente
            pourrait impliquer le transfert des données personnelles détenues
            par la COMPAGNIE à l'organisation acquérante.  Dans une telle
            circonstance, la COMPAGNIE fournira un avis approprié et des
            mécanismes de consentement aux individus tel que requis par les lois
            applicables.Est-ce que la COMPAGNIE transfère des données
            personnelles à travers les frontières ? La COMPAGNIE peut
            recueillir, traiter, utiliser, conserver et transférer des données
            personnelles à travers les frontières afin d'atteindre nos objectifs
            d'utilisation tels que décrits ci-dessus dans la section 2.  Cela
            peut inclure des transferts de données personnelles vers des pays
            qui peuvent ne pas avoir de lois sur la confidentialité ou la
            protection des données équivalentes à celles de votre propre pays.
             Cependant, quel que soit l'endroit où nous transférons les données
            personnelles, la COMPAGNIE prend les mesures appropriées pour
            s'assurer que vos données personnelles bénéficient de normes de
            soins cohérentes.  Cela inclut la signature de contrats entre les
            sociétés affiliées de l'ENTREPRISE et avec nos vendeurs et
            fournisseurs pour s'assurer que les deux parties suivent des
            principes, processus et protections cohérents en matière de
            confidentialité et de sécurité.Pour les transferts impliquant des
            données personnelles européennes, l'ENTREPRISE utilise des clauses
            contractuelles standard avec ses partenaires.  Comment l'ENTREPRISE
            protège-t-elle les données personnelles ? L'ENTREPRISE croit que la
            confidentialité et la sécurité vont de pair.  Nous utilisons des
            contrôles physiques, techniques et administratifs appropriés pour
            protéger les données personnelles dont nous sommes responsables.
             Cela inclut le cryptage et d'autres mesures de sécurité renforcées,
            lorsque cela est approprié ou requis.  Nous prenons également les
            mesures appropriées pour nous assurer que nos vendeurs, fournisseurs
            et certains autres partenaires adoptent des normes cohérentes de
            protection des données personnelles dont la SOCIÉTÉ est responsable.
              Cependant, il est important de noter qu'aucune technologie n'est
            garantie comme étant invulnérable aux menaces ou aux attaques.  Par
            conséquent, veuillez vous assurer de faire preuve de prudence
            lorsque vous utilisez un site Web ou un produit.  Si la technologie
            que vous utilisez est configurée avec des contrôles ou des
            caractéristiques de confidentialité ou de sécurité, veuillez vous
            assurer de les utiliser.Comment puis-je réviser, corriger, modifier
            ou supprimer mes données personnelles ? De plus, en vertu de la
            présente déclaration de confidentialité et de certaines lois
            applicables, vous pouvez soumettre une demande à la COMPAGNIE pour
            réviser, corriger, modifier ou supprimer les données personnelles
            que la COMPAGNIE possède à votre sujet.  Vous pouvez également avoir
            le droit de demander une copie lisible par machine de vos données
            personnelles. Pour soumettre une telle demande à la COMPAGNIE,
            veuillez nous contacter à support@usenode.com . Veuillez noter que
            nous examinerons ces demandes, y répondrons et y donnerons suite
            dans les meilleurs délais et conformément aux lois applicables.
             Nous sommes également tenus de vérifier votre identité avant de
            vous accorder l'accès à vos données personnelles.  Si vous avez un
            compte de la SOCIÉTÉ, nous pouvons vérifier votre identité en vous
            demandant de vous connecter à votre compte. Si vous ne disposez pas
            d'un compte de la SOCIÉTÉ ou d'une adresse électronique dans nos
            dossiers, nous pouvons vous demander des informations
            supplémentaires limitées afin de vérifier votre identité. Veuillez
            noter que si vous n'avez pas de compte avec la COMPAGNIE, ou une
            adresse électronique dans nos dossiers, ou si nous sommes incapables
            de vérifier votre identité dans nos dossiers, nous pouvons refuser
            votre demande.Vous pouvez également utiliser un agent autorisé pour
            soumettre une demande en vertu de cette section en votre nom. Si
            vous choisissez de demander à un agent autorisé de soumettre une
            telle demande en votre nom, la SOCIÉTÉ exigera : (i) que vous
            fournissiez à l'agent autorisé la permission écrite de le faire ; et
            (ii) que votre agent vérifie son identité directement auprès de la
            COMPAGNIE.  En outre, vous avez le droit de poser des questions ou
            de déposer des plaintes auprès de votre autorité nationale de
            protection des données en tout temps. Comment puis-je contacter la
            COMPAGNIE ? Si vous avez des questions, des plaintes ou des
            préoccupations supplémentaires concernant la confidentialité à la
            COMPAGNIE. N'hésitez pas à nous joindre à l'adresse suivante :
            support@usenode.com CONDITIONS D'UTILISATION POUR NODE TECHNOLOGIES,
            INC. Les conditions suivantes régissent l'utilisation de tous les
            contenus, services et produits (le " service ") fournis par NODE
            TECHNOLOGIES, INC. (" NODE ") et disponibles sur les sites NODE (le
            " site "). Le Service est détenu et exploité par NODE. Le Site est
            destiné à être utilisé par des sociétés (" Société(s) ") et des
            clients (" Client(s) " avec les Sociétés " Utilisateur " ou "
            Utilisateurs ") en relation avec les Services.Le Service est offert
            sous réserve de votre acceptation sans modification de toutes les
            conditions générales contenues dans le présent document et de toutes
            les autres règles, politiques et procédures d'exploitation qui
            peuvent être publiées de temps à autre sur le Site (collectivement,
            le " Contrat "). Si vous concluez le présent Contrat au nom d'une
            société ou d'une autre entité juridique, vous déclarez avoir le
            pouvoir de lier cette entité, ses sociétés affiliées et tous les
            utilisateurs qui accèdent au Service par le biais de votre compte au
            présent Contrat, auquel cas les termes " vous " ou " votre " feront
            référence à cette entité, à ses sociétés affiliées et aux
            utilisateurs qui lui sont associés. Si vous n'avez pas cette
            autorité, ou si vous n'êtes pas d'accord avec ces termes et
            conditions, vous ne devez pas accepter cet Accord et ne pouvez pas
            utiliser le Service.VEUILLEZ LIRE ATTENTIVEMENT CET ACCORD AVANT
            D'ACCÉDER À NOTRE SITE OU D'UTILISER LE SERVICE. EN ACCÉDANT OU EN
            UTILISANT TOUTE PARTIE DU SITE, VOUS ACCEPTEZ D'ÊTRE LIÉ PAR CET
            ACCORD. CES CONDITIONS COMPRENNENT UNE CLAUSE D'ARBITRAGE
            OBLIGATOIRE ET UNE RENONCIATION AUX RECOURS COLLECTIFS. Si vous
            n'acceptez pas tous les termes et conditions du présent accord, vous
            ne pouvez pas accéder au service. Si ces conditions sont considérées
            comme une offre par NODE, l'acceptation est expressément limitée à
            ces conditions.NODE ET SON SITE SONT UNE PLATE-FORME ET NE SONT PAS
            PARTIES D'UN ACCORD DE SERVICES OU D'UNE AUTRE TRANSACTION ENTRE LES
            UTILISATEURS DU SITE.NODE agit comme un lieu où les utilisateurs du
            site peuvent visualiser et publier des services sur le site. NODE
            n'est pas partie à un accord ou à une transaction réelle entre les
            utilisateurs, même si nous pouvons de temps à autre fournir des
            outils liés à une telle transaction, comme un outil permettant le
            paiement de services. Par conséquent, NODE n'a aucun contrôle sur
            l'exactitude ou la justesse du contenu ou des informations fournies
            ou utilisées par ces sociétés et clients. Toute partie d'une
            transaction réelle ou potentielle entre une Entreprise et un Client,
            y compris l'état, la qualité, la sécurité des services annoncés, la
            véracité ou l'exactitude du service (y compris son contenu ou toute
            critique s'y rapportant), la capacité des Entreprises à fournir des
            services, ou la capacité des Clients à payer les services sont de la
            seule responsabilité de chaque Utilisateur. Accords distincts. Les
            utilisateurs reconnaissent et acceptent qu'il leur sera demandé de
            conclure un accord et/ou une renonciation séparés, directement entre
            la société et le client, avant d'acheter un produit ou un service,
            et que cet accord et/ou cette renonciation peuvent imposer des
            restrictions supplémentaires sur votre produit ou service. Tout
            accord et/ou renonciation distinct relatif aux produits ou services
            est sous le contrôle exclusif de la société et du client.Conditions
            générales relatives aux comptesVous devez être un être humain. Les
            comptes enregistrés par des "robots" ou autres méthodes automatisées
            ne sont pas autorisés.Chaque compte ne peut être utilisé que par une
            seule personne et vous ne pouvez avoir qu'un seul compte. S'il est
            découvert que vous avez enregistré plusieurs comptes, que vous
            partagez des comptes avec une autre personne ou que vous accédez au
            site par le biais d'un compte qui n'est pas le vôtre, tous les
            comptes concernés par une telle utilisation seront résiliés.Vous
            êtes responsable du maintien de la sécurité de votre compte et de
            votre mot de passe. Vous êtes responsable de la sécurité de votre
            compte et de votre mot de passe. NODE ne peut pas et ne sera pas
            responsable de toute perte ou de tout dommage résultant de votre
            manquement à cette obligation de sécurité. Vous êtes entièrement
            responsable de toutes les activités qui se produisent sous le compte
            et de toutes les autres actions prises en relation avec le compte.
            Vous devez immédiatement informer NODE de toute utilisation non
            autorisée de votre compte, ou de toute autre violation de la
            sécurité. NODE ne sera pas responsable des actes ou omissions de
            votre part, y compris des dommages de toute nature encourus à la
            suite de ces actes ou omissions. Vous ne devez pas utiliser le
            service à des fins illégales ou non autorisées. Vous ne devez pas,
            dans l'utilisation du Service, violer les lois de votre juridiction
            (y compris, mais sans s'y limiter, les lois sur les droits d'auteur
            ou les marques commerciales). Peu importe ce qui est dit dans les
            présentes conditions ou ailleurs dans les services, vous
            reconnaissez expressément que vous n'avez aucun droit, titre ou
            intérêt dans un compte que vous créez par l'intermédiaire de nos
            services, et que votre compte n'est pas votre propriété.En utilisant
            le site, vous garantissez et déclarez que vous avez au moins 18 ans
            et que vous êtes légalement compétent pour lire, comprendre et
            accepter les dispositions du présent accord. Si vous avez moins de
            18 ans, vous ne devez pas utiliser une partie du site, créer un
            compte ou soumettre des informations personnelles à NODE par le
            biais du site. NODE peut supprimer le contenu qui viole le contrat à
            sa seule discrétion. La suppression du contenu ou la fermeture d'un
            compte ne sont pas des actions que NODE prend à la légère, et nous
            pouvons prendre un certain temps pour enquêter et déterminer si de
            telles actions sont justifiées. CommunicationEn utilisant ce site et
            nos services, vous donnez à NODE l'autorisation expresse de vous
            contacter par courrier électronique, messagerie ou toute autre forme
            de communication électronique ou non électronique à toutes fins, y
            compris la distribution de matériel de marketing et de
            promotion.Nous fournissons des services interactifs sur notre site,
            y compris, sans s'y limiter, des salons de discussion et des
            tableaux d'affichage. Nous prendrons des mesures raisonnables pour
            évaluer les risques éventuels pour les Utilisateurs de la part de
            tiers lorsqu'ils utilisent un service interactif fourni sur notre
            Site, et nous déciderons dans chaque cas s'il est approprié
            d'utiliser la modération du Service concerné (y compris le type de
            modération à utiliser) à la lumière de ces risques. Cependant, nous
            n'avons aucune obligation de superviser, contrôler ou modérer tout
            service interactif que nous fournissons sur notre Site, et nous
            excluons expressément notre responsabilité pour toute perte ou tout
            dommage résultant de l'utilisation de tout service interactif par un
            utilisateur en violation de nos normes de contenu, que le Service
            soit modéré ou non. En cas de difficulté, l'utilisateur doit nous
            contacter en envoyant un e-mail à support@usenode.com
            immédiatement.ContenuSi vous mettez (ou permettez à un tiers de
            mettre) du matériel à disposition par le biais du site (ce matériel,
            le "contenu"), vous êtes entièrement responsable du contenu et de
            tout préjudice résultant de ce contenu. Cela vaut indépendamment du
            fait que le contenu en question soit du texte, des graphiques, un
            fichier audio ou un logiciel informatique. En mettant le Contenu à
            disposition, vous déclarez et garantissez que : le téléchargement,
            la copie et l'utilisation du contenu n'enfreindront pas les droits
            de propriété, y compris, mais sans s'y limiter, les droits d'auteur,
            de brevet, de marque ou de secret commercial, d'un tiers ; si votre
            employeur a des droits sur la propriété intellectuelle que vous
            créez, vous avez soit (i) reçu l'autorisation de votre employeur de
            publier ou de mettre à disposition le contenu, y compris, mais sans
            s'y limiter, tout logiciel, soit (ii) obtenu de votre employeur une
            renonciation à tous les droits sur le contenu ; vous vous êtes
            pleinement conformé aux licences de tiers relatives au contenu et
            avez fait tout ce qui était nécessaire pour transmettre avec succès
            aux utilisateurs finaux les conditions requises ; le contenu ne
            contient ni n'installe aucun virus, ver, logiciel malveillant,
            cheval de Troie ou autre contenu nuisible ou destructeur ; le
            contenu n'est pas un spam, n'est pas généré par une machine ou de
            manière aléatoire, et ne contient pas de contenu commercial non
            éthique ou indésirable conçu pour attirer du trafic vers des sites
            tiers ou améliorer le classement des sites tiers dans les moteurs de
            recherche, ou pour favoriser des actes illégaux (comme le phishing)
            ou tromper les destinataires quant à la source du matériel (comme
            l'usurpation d'identité) ; le contenu n'est pas pornographique, ne
            contient pas de menaces ou n'incite pas à la violence, et ne viole
            pas les droits à la vie privée ou à la publicité d'un tiers;le
            contenu ne fait pas l'objet d'une publicité par le biais de messages
            électroniques indésirables tels que des liens de spam sur des
            groupes de discussion, des listes d'adresses électroniques, d'autres
            groupes et sites web, et d'autres méthodes promotionnelles non
            sollicitées similaires;le contenu n'est pas nommé de manière à faire
            croire à vos lecteurs que vous êtes une autre personne ou une autre
            société ;  et vous avez, dans le cas d'un contenu comprenant un code
            informatique, catégorisé et/ou décrit avec précision le type, la
            nature, les utilisations et les effets du matériel, que cela vous
            ait été demandé par NODE ou autrement.B. Sans limiter l'une de ces
            déclarations ou garanties, NODE a le droit (mais pas l'obligation),
            à la seule discrétion de NODE : de refuser ou de supprimer tout
            contenu qui, selon l'opinion raisonnable de NODE, viole toute
            politique de NODE ou est de quelque manière que ce soit nuisible ou
            répréhensible, ou de mettre fin ou de refuser l'accès et
            l'utilisation du service à toute personne ou entité pour toute
            raison. NODE n'aura aucune obligation de rembourser les montants
            précédemment payés. En tant qu'utilisateur, vous pouvez désactiver
            votre compte à tout moment. Les informations d'identification
            personnelle telles que votre nom, votre nom d'utilisateur et votre
            photo de profil ne seront plus associées au contenu que vous avez
            publié. Nos frais Vous acceptez de payer à NODE les frais indiqués
            pour le service. Lorsqu'un utilisateur procède a un paiement par un
            module externe à l'entreprise partenaire. Un frais de 5% du montant
            total de la transaction (maximum 2,51$ taxes incluses) est facturé à
            l'utilisateur payeur. Si l'utilisateur payeur procède à un paiement
            par un widget externe ou encore par l'application mobile de Node, il
            sera automatiquement facturé avec une transaction indépendante.
            Remboursements Tous les frais ne sont pas remboursables. Les
            demandes de remboursement seront examinées et déterminées au cas par
            cas. NODE se réserve le droit, à sa discrétion raisonnable, de
            refuser de rembourser les frais.PaiementsPour utiliser certains
            services du site, vous devez fournir des informations de compte pour
            au moins une méthode de paiement valide.Vous autorisez NODE, par la
            présente, à exécuter des autorisations de carte de crédit sur toutes
            les cartes de crédit que vous avez fournies, à stocker les cartes de
            crédit et les détails bancaires ou autres détails financiers comme
            votre méthode de paiement conformément à notre déclaration de
            confidentialité des clients, et à débiter votre carte de crédit (ou
            toute autre méthode de paiement) pour les frais et tout autre
            montant dû en vertu du contrat. Dans la mesure où la loi applicable
            le permet et sous réserve de notre Déclaration de confidentialité,
            vous reconnaissez et acceptez que nous puissions faire appel à
            certains vendeurs et prestataires de services tiers pour traiter les
            paiements et gérer les informations relatives à votre mode de
            paiement.En fournissant des informations relatives au mode de
            paiement par le biais du Site et en autorisant les paiements avec le
            mode de paiement, vous déclarez, garantissez et convenez que : (a)
            vous êtes légalement autorisé à fournir ces informations ; (b) vous
            êtes légalement autorisé à effectuer des paiements en utilisant
            le(s) moyen(s) de paiement ; (c) si vous êtes un employé ou un agent
            d'une société ou d'une personne qui possède le moyen de paiement,
            vous êtes autorisé par la société ou la personne à utiliser le moyen
            de paiement pour effectuer des paiements ; et (d) ces actions ne
            violent pas les termes et conditions applicables à votre utilisation
            de ce(s) moyen(s) de paiement ou la loi applicable.Politique en
            matière de droits d'auteurNODE respecte la loi sur les droits
            d'auteur et attend de ses utilisateurs qu'ils fassent de même. La
            politique de NODE est de mettre fin, dans des circonstances
            appropriées, aux utilisateurs ou autres titulaires de compte qui
            enfreignent de manière répétée ou sont soupçonnés d'enfreindre de
            manière répétée les droits des titulaires de droits
            d'auteur.Propriété intellectuelle de NODELes services contiennent
            des matériaux propriétaires tels que des logos, des textes, des
            logiciels, des photos, des vidéos, des graphiques, de la musique et
            des sons. NODE est le propriétaire ou le licencié de tout ce
            matériel propriétaire et de tous les droits de propriété
            intellectuelle qui s'y rapportent, y compris, mais sans s'y limiter,
            les droits d'auteur et les marques commerciales. En utilisant les
            services, vous acceptez de ne pas télécharger en amont, télécharger,
            distribuer ou reproduire de quelque manière que ce soit ces
            matériaux propriétaires sans avoir obtenu le consentement préalable
            de NODE. Conditions de licence du logiciel Nous sommes propriétaires
            du logicielLes systèmes et logiciels de NODE (" Logiciel ") (y
            compris toutes les versions, révisions, mises à jour ou
            améliorations du Logiciel) et toute documentation qui accompagne ou
            est mise à disposition en relation avec le Logiciel (y compris toute
            information d'abonnement ou d'achat, emballage du produit) (la "
            Documentation "), sont la propriété de NODE ou de ses concédants.
            Ceci inclut tous les droits de propriété intellectuelle relatifs au
            logiciel et à la documentation. Tout logiciel que NODE vous fournit
            est concédé sous licence, et non vendu, et NODE se réserve tous les
            droits sur le logiciel qui ne sont pas expressément accordés dans
            les présentes conditions de licence de logiciel.Tant que vous
            respectez les conditions générales du contrat, NODE vous accorde une
            licence limitée non exclusive et non transférable, sans droit de
            sous-licence, pour télécharger et installer une copie du logiciel
            sur un dispositif mobile, un ordinateur ou une tablette que vous
            possédez ou contrôlez et pour exécuter cette copie du logiciel
            uniquement aux fins d'accéder aux services et de les utiliser
            lorsque les services correspondants sont disponibles pour votre
            utilisation pendant la période d'abonnement applicable. Vous ne
            pouvez pas : (i) copier, modifier ou créer des œuvres dérivées
            basées sur le Logiciel ; (ii) distribuer, transférer, accorder une
            sous-licence, louer ou prêter le Logiciel à un tiers ; (iii) faire
            de l'ingénierie inverse, décompiler ou désassembler le Logiciel ; ou
            (iv) mettre les fonctionnalités du Logiciel à la disposition de
            tiers, sauf et seulement dans la mesure où la loi applicable
            l'autorise expressément.Les présentes Conditions vous permettent
            d'installer une seule copie du Logiciel pour une utilisation sur un
            seul ordinateur, appareil mobile ou tablette, sauf si votre
            abonnement aux Services vous permet expressément d'utiliser le
            Logiciel sur plus d'un appareil. Vous pouvez faire une copie du
            Logiciel à des fins de sauvegarde ou d'archivage ou copier le
            Logiciel sur le disque dur de votre appareil et conserver l'original
            à des fins de sauvegarde ou d'archivage uniquement.À l'expiration ou
            à toute résiliation des présentes Conditions, vous devez cesser
            d'utiliser et détruire toutes les copies du Logiciel et de la
            Documentation en votre possession.Il peut y avoir des mesures
            technologiques dans le Logiciel qui sont conçues pour empêcher
            l'utilisation sans licence ou illégale du Logiciel. Vous acceptez
            que NODE puisse utiliser ces mesures pour protéger NODE contre le
            piratage du logiciel (par exemple, le logiciel peut contenir une
            technologie d'application qui limite la possibilité d'installer et
            de désinstaller le logiciel sur un dispositif à un nombre limité de
            fois pour un nombre limité de dispositifs). Vous devrez peut-être
            activer ces mesures technologiques. Si tel est le cas, le Logiciel
            ne fonctionnera que pendant une période limitée avant son activation
            par vos soins. Lors de l'activation, il peut vous être demandé de
            fournir un code d'activation unique accompagnant le Logiciel et la
            configuration du dispositif sous la forme d'un code alphanumérique
            sur Internet afin de vérifier l'authenticité du Logiciel. Si vous
            n'effectuez pas l'activation dans le délai imparti ou selon les
            instructions du logiciel, le logiciel cessera de fonctionner jusqu'à
            ce que l'activation soit terminée, après quoi les fonctionnalités du
            logiciel seront rétablies. Si vous ne parvenez pas à activer le
            logiciel au cours du processus d'activation, vous pouvez contacter
            NODE en utilisant les informations fournies lors de l'activation ou
            par le fournisseur du logiciel.ModificationsNous nous réservons le
            droit de modifier le contrat à tout moment et les conditions
            modifiées entrent en vigueur dès leur publication sur le site. Nous
            ferons des efforts raisonnables pour vous informer de ces
            modifications par e-mail ou par le biais du Service. Le fait de
            continuer à utiliser ou à accéder au service après l'affichage de
            toute modification de la présente convention constitue une
            acceptation de ces modifications. NODE peut également, à l'avenir,
            proposer de nouveaux services et/ou fonctionnalités, y compris la
            mise à disposition de nouveaux outils et ressources. Ces nouvelles
            fonctionnalités et/ou services seront soumis aux conditions
            générales du présent contrat.DonnéesLes utilisateurs peuvent
            demander des données relatives à leur compte personnel et à leur(s)
            groupe(s) respectivement. NODE a le droit de refuser les demandes
            répétitives ou techniquement difficiles. Pour plus d'informations
            sur la manière dont nous recueillons et partageons les informations
            sur les utilisateurs, veuillez vous référer à notre Déclaration de
            confidentialité.Exclusion de garantiesLe service est fourni "TEL
            QUEL" et "TEL QUE DISPONIBLE". NODE ET SES DIRIGEANTS,
            ADMINISTRATEURS, EMPLOYÉS, AGENTS, FILIALES, AFFILIÉS, CONCÉDANTS ET
            FOURNISSEURS REJETTENT EXPRESSÉMENT TOUTE GARANTIE DE QUELQUE NATURE
            QUE CE SOIT, EXPRESSE OU IMPLICITE, Y COMPRIS, MAIS SANS S'Y
            LIMITER, LES GARANTIES IMPLICITES DE TITRE, DE QUALITÉ MARCHANDE, DE
            NON-VIOLATION ET D'ADÉQUATION À UN USAGE PARTICULIER. NI NODEN, NI
            SES DIRIGEANTS, ADMINISTRATEURS, EMPLOYÉS, AGENTS, FILIALES,
            SOCIÉTÉS AFFILIÉES, CONCÉDANTS DE LICENCE OU FOURNISSEURS NE
            GARANTISSENT QUE LE FONCTIONNEMENT DU SERVICE SERA ININTERROMPU,
            SANS ERREUR OU SANS VIOLATION DE LA SÉCURITÉ. NODE, SES DIRIGEANTS,
            ADMINISTRATEURS, EMPLOYÉS, AGENTS, FILIALES, SOCIÉTÉS AFFILIÉES ET
            SES CONCÉDANTS DE LICENCE NE DÉCLARENT NI NE GARANTISSENT QUE :LES
            INFORMATIONS FOURNIES SUR LE SITE SONT VRAIES OU CORRECTES,VOTRE
            UTILISATION DES SERVICES RÉPONDRA À VOS EXIGENCES OU ATTENTES,VOTRE
            UTILISATION DES SERVICES SERA ININTERROMPUE, OPPORTUNE, SÉCURISÉE OU
            EXEMPTE D'ERREURS,TOUTE INFORMATION OBTENUE PAR VOUS SUITE À VOTRE
            UTILISATION DES SERVICES SERA PRÉCISE OU FIABLE,OU QUE LES DÉFAUTS
            DANS LE FONCTIONNEMENT OU LA FONCTIONNALITÉ DE TOUT LOGICIEL QUI
            VOUS EST FOURNI DANS LE CADRE DES SERVICES SERONT CORRIGÉS.
            Limitation de responsabilitéEN AUCUN CAS, NODE, ses dirigeants,
            administrateurs, employés, agents, filiales ou sociétés affiliées ne
            seront tenus responsables envers une partie quelconque pour : TOUT
            DOMMAGE DIRECT, INDIRECT, ACCESSOIRE, CONSÉCUTIF, SPÉCIAL,
            EXEMPLAIRE OU PUNITIF RÉSULTANT DE L'UTILISATION, DE LA
            DISPONIBILITÉ OU DE L'INDISPONIBILITÉ DES SERVICES (Y COMPRIS, MAIS
            SANS S'Y LIMITER, L'INDISPONIBILITÉ OU LA MODIFICATION DES SERVICES
            ANNONCÉS) OU DE TOUT AUTRE SERVICE OU BIEN OBTENU PAR L'UTILISATION
            DE L'UN DES ÉLÉMENTS PRÉCITÉS, OU DE TOUTE DONNÉE TRANSMISE PAR LE
            BIAIS DU SERVICE, MÊME SI NODE A ÉTÉ INFORMÉ DE LA POSSIBILITÉ DE
            TELS DOMMAGES ; ET TOUTE PERTE OU TOUT DOMMAGE QUE VOUS POURRIEZ
            SUBIR, Y COMPRIS, MAIS SANS S'Y LIMITER, TOUTE PERTE OU TOUT DOMMAGE
            RÉSULTANT DE : TOUTE CONFIANCE QUE VOUS ACCORDEZ À L'EXHAUSTIVITÉ, À
            L'EXACTITUDE OU À L'EXISTENCE DE TOUTE PUBLICITÉ, OU EN TANT QUE
            RÉSULTAT DE TOUTE RELATION OU TRANSACTION ENTRE VOUS ET TOUT
            ANNONCEUR OU SPONSOR DONT LA PUBLICITÉ APPARAÎT SUR LES SERVICES ;
            TOUTE MODIFICATION QUE NODE PEUT APPORTER AUX SERVICES, OU TOUTE
            CESSATION PERMANENTE OU TEMPORAIRE DE LA FOURNITURE DES SERVICES (OU
            DE TOUTE FONCTION AU SEIN DES SERVICES) ; VOTRE INCAPACITÉ À FOURNIR
            À NODE DES INFORMATIONS EXACTES ; VOTRE INCAPACITÉ À CONSERVER VOTRE
            MOT DE PASSE OU LES DÉTAILS DE VOTRE COMPTE DE MANIÈRE SÉCURISÉE ET
            CONFIDENTIELLE. TOUTE BLESSURE CORPORELLE, TOUT DÉCÈS OU TOUT
            DOMMAGE MATÉRIEL POUVANT SURVENIR EN RAISON DES SERVICES. NONOBSTANT
            LES CONDITIONS, NODE NE SERA EN AUCUN CAS TENU RESPONSABLE DE TOUT
            MONTANT SUPÉRIEUR À (DANS L'ENSEMBLE) CENT DOLLARS AMÉRICAINS
            (100,00 $).  NODE NE POURRA ÊTRE TENU RESPONSABLE DE TOUTE
            DÉFAILLANCE OU DE TOUT RETARD DÛ À DES QUESTIONS ÉCHAPPANT À SON
            CONTRÔLE RAISONNABLE. LES DISPOSITIONS PRÉCÉDENTES NE S'APPLIQUENT
            PAS DANS LA MESURE OÙ LA LOI APPLICABLE L'INTERDIT.
            IndemnisationVous acceptez d'indemniser, de libérer, de défendre et
            de dégager de toute responsabilité NODE et ses administrateurs,
            dirigeants, agents et employés (collectivement, les " parties NODE
            ") en cas de réclamations, causes d'action, demandes, recouvrements,
            pertes, dommages (réels et consécutifs), amendes, pénalités et
            autres coûts ou dépenses, de toute sorte ou nature, y compris, mais
            sans s'y limiter, les frais juridiques et comptables raisonnables
            (collectivement, les " réclamations "), connus et inconnus,
            découlant de ou liés de quelque manière que ce soit à ces litiges, y
            compris, mais sans s'y limiter, les litiges découlant de la
            violation du présent accord, de la violation de tout accord ou
            transaction séparé, et/ou de la substitution d'unités. En outre,
            vous acceptez par la présente d'indemniser, de libérer, de défendre
            et de dégager les parties NODE de toute responsabilité en cas de
            réclamation résultant de votre (1) violation des conditions, (2)
            violation de toute loi ou des droits d'un tiers, et (3) utilisation
            de ce site et des services. Règlement des différendsLe présent
            contrat constitue l'intégralité de l'accord entre NODE et vous
            concernant l'objet des présentes, et il ne peut être modifié que par
            un amendement écrit signé par un agent/employé autorisé de la
            SOCIÉTÉ, ou par l'affichage par NODEco d'une version révisée. Tout
            litige découlant du présent contrat, de sa résiliation ou de notre
            relation avec vous sera déterminé par l'application des lois de
            l'État du Delaware. Si une partie du présent contrat est jugée
            invalide ou inapplicable, cette partie sera supprimée, et les autres
            parties resteront en vigueur et de plein effet. La renonciation par
            l'une ou l'autre des parties à un terme ou à une condition du
            présent accord ou à une violation de celui-ci, dans un cas donné,
            n'entraînera pas la renonciation à ce terme ou à cette condition ou
            à toute violation ultérieure de celui-ci. Vous ne pouvez pas céder
            vos droits en vertu du présent contrat sans le consentement écrit de
            NODE ;  NODE peut céder ses droits en vertu du présent contrat sans
            condition. Le présent contrat lie les parties, leurs successeurs et
            leurs ayants droit autorisés et s'applique à leur profit. ARBITRAGE
            Résolution des litiges et arbitrageEn utilisant ce site, vous
            acceptez que tous les litiges, réclamations ou controverses que vous
            pourriez avoir à l'encontre de NODE, découlant de, se rapportant à
            ou liés de quelque manière que ce soit à (i) votre utilisation de ce
            site (ii) tout service obtenu ou fourni par NODE ou (iii) cet accord
            (y compris l'interprétation et la portée de cette clause et
            l'arbitrabilité du litige), seront résolus exclusivement par un
            arbitrage obligatoire et contraignant initié et administré par
            l'American Arbitration Association (" AAA "). Vous convenez
            également que l'arbitrage sera mené par un arbitre unique
            conformément aux règles et procédures applicables établies par
            l'AAA, et que toute procédure d'arbitrage, si nécessaire, aura lieu
            à Montréal, au Canada, ou à tout autre endroit convenu mutuellement
            par NODE et vous. L'arbitrage sera soumis à la Loi fédérale sur
            l'arbitrage et non à une loi d'arbitrage d'état. L'arbitre
            appliquera la loi de Montréal, Canada, conformément à la Loi
            fédérale sur l'arbitrage, et honorera les revendications de
            privilège reconnues par la loi. Afin d'initier l'arbitrage avec
            l'AAA, vous pouvez être responsable de payer des frais de dépôt à
            l'AAA, cependant, dans le cas où vous êtes en mesure de démontrer
            que les coûts de l'arbitrage seront prohibitifs par rapport aux
            coûts du litige, NODE remboursera autant de vos frais de dépôt et
            d'audience en relation avec l'arbitrage que l'arbitre juge
            nécessaire pour empêcher l'arbitrage d'être prohibitif. Il n'y aura
            aucun droit ou autorité pour que les réclamations soient arbitrées
            sur une base de recours collectif ou de représentation. VOUS
            COMPRENEZ ET ACCEPTEZ QU'EN ACCEPTANT CES CONDITIONS GÉNÉRALES, VOUS
            ET NODE RENONCEZ CHACUN AU DROIT À UN PROCÈS DEVANT UN JURY OU À LA
            PARTICIPATION À UN RECOURS COLLECTIF EN CE QUI CONCERNE LES
            RÉCLAMATIONS COUVERTES PAR CETTE DISPOSITION D'ARBITRAGE
            OBLIGATOIRE. Vous renoncez ainsi à votre droit d'aller en justice
            pour faire valoir ou défendre vos droits. Vos droits seront
            déterminés par un arbitre neutre, et non par un juge ou un jury.
            Toutes les réclamations que vous déposez contre NODE doivent être
            résolues conformément à cette clause d'arbitrage. Toutes les
            réclamations déposées ou introduites par vous contrairement à cette
            disposition seront considérées comme irrégulièrement déposées et
            nulles. Si vous déposez une réclamation contraire à cette
            disposition d'arbitrage, NODE vous informera par écrit de la
            réclamation incorrectement déposée, et vous devrez rapidement
            retirer la réclamation.  Si vous ne retirez pas rapidement la
            réclamation après avoir reçu un avis écrit de NODE, NODE peut
            récupérer ses frais d'avocat et ses coûts raisonnables engagés pour
            faire appliquer cette disposition d'arbitrage.Avis ; processusUne
            partie qui a l'intention de demander un arbitrage doit d'abord
            envoyer un avis écrit du différend à l'autre partie, par courrier
            certifié, Federal Express, UPS ou Express Mail (signature requise),
            ou dans le cas où nous n'avons pas d'adresse physique dans nos
            dossiers, par courrier électronique (" Avis "). L'adresse de NODE
            pour la notification est : support@usenode.com.The. La notification
            doit (1) décrire la nature et la base de la réclamation ou du litige
            ; et (2) énoncer la réparation spécifique demandée (" Demande ").
            Nous acceptons de faire des efforts de bonne foi pour résoudre la
            demande directement, mais si nous ne parvenons pas à un accord dans
            les 30 jours suivant la réception de la notification, vous ou NODE
            pouvez entamer une procédure d'arbitrage. Au cours de l'arbitrage,
            le montant de toute offre de règlement faite par vous ou NODE ne
            sera divulgué à l'arbitre qu'après que l'arbitre ait rendu une
            décision et une sentence définitives, le cas échéant. Tous les
            documents et informations divulgués au cours de l'arbitrage seront
            gardés strictement confidentiels par le destinataire et ne seront
            pas utilisés par le destinataire à d'autres fins que celles de
            l'arbitrage ou de l'exécution de la décision et de la sentence de
            l'arbitre et ne seront pas divulgués, sauf à titre confidentiel, aux
            personnes qui ont besoin de les connaître à ces fins ou comme
            l'exige la loi applicable. ApplicabilitéSi une partie de cette
            clause d'arbitrage est jugée invalide, inapplicable ou illégale, ou
            si elle entre en conflit avec les règles et procédures établies par
            l'AAA, le reste de cette clause d'arbitrage restera en vigueur et
            sera interprété conformément à ses termes comme si la clause
            invalide, inapplicable, illégale ou conflictuelle n'était pas
            contenue dans les présentes. Divers Conformité générale aux loisVous
            devez vous conformer à l'ensemble des lois, statuts, ordonnances et
            règlements applicables concernant votre utilisation des
            services.TitresLes titres ne servent qu'à des fins de référence et
            ne définissent, limitent, interprètent ou décrivent en aucun cas la
            portée ou l'étendue de cette section.Intégralité de l'accordLe
            présent accord constitue l'intégralité de l'accord entre NODE et
            vous concernant l'objet des présentes, et il ne peut être modifié
            que par un amendement écrit signé par un agent/employé autorisé de
            NODE, ou par la publication par NODE d'une version révisée. Loi
            applicableLes conditions du présent contrat seront interprétées
            conformément aux lois substantielles de l'État du Delaware,
            États-Unis d'Amérique, sans donner effet aux principes de conflit ou
            de choix de loi de cet État. Le siège social de l'entreprise est
            située au Québec, Canada. La forme originale du présent accord a été
            rédigée en anglais. Les parties aux présentes renoncent à tout
            statut, loi ou règlement qui pourrait fournir une loi ou un forum
            alternatif ou qui pourrait exiger que cet accord soit rédigé dans
            une autre langue que l'anglais. Le présent accord exclut
            expressément la Convention des Nations Unies sur les contrats de
            vente internationale de marchandises.DivisibilitéSi une partie du
            présent accord est jugée invalide ou inapplicable, cette partie sera
            supprimée, et les autres parties resteront en vigueur et de plein
            effet.RenonciationLa renonciation par l'une ou l'autre des parties à
            une condition du présent accord ou à une violation de celle-ci, dans
            un cas donné, n'entraîne pas la renonciation à cette condition ou à
            toute violation ultérieure de celle-ci. Cession Vous ne pouvez pas
            céder vos droits en vertu du présent contrat sans le consentement
            écrit de NODE ; NODE peut céder ses droits en vertu du présent
            contrat sans condition. Le présent contrat lie les parties, leurs
            successeurs et leurs ayants droit autorisés et s'applique à leur
            profit.RésiliationNODE peut immédiatement émettre un avertissement,
            suspendre temporairement, suspendre indéfiniment ou résilier votre
            utilisation de la totalité ou d'une partie des services si vous ne
            respectez pas les conditions, ou à tout moment ou pour toute raison,
            à la seule discrétion de NODE. Force Majeure NODE ne sera pas
            responsable de tout retard ou défaut d'exécution en rapport avec les
            services ou dans l'exécution de toute obligation en vertu des
            présentes, si un tel retard ou défaut est dû ou causé de quelque
            manière que ce soit par un cas de force majeure, une rébellion, des
            émeutes, un détournement, une insurrection, des troubles civils, des
            grèves ou des conflits du travail, des incendies, des inondations,
            des lois, des règlements, des actes, des demandes ou des ordres de
            tout gouvernement ou agence, ou toute autre cause indépendante de la
            volonté de NODE. Par la présente, vous libérez NODE de toute
            réclamation ou demande de dommages directs ou indirects découlant
            d'un défaut d'exécution résultant d'un événement de force majeure,
            qu'il soit ou non énuméré dans les présentes, ou de tout autre
            événement mentionné ci-dessus. Contacter la société Si vous avez des
            questions concernant les présentes conditions de service, veuillez
            contacter NODE à l'adresse support@usenode.com.          NODE
            TECHNOLOGIES, INC. (“COMPANY”) values your privacy.  To learn more
            about what personal and user data COMPANY collects, uses, retains
            and shares; how we protect your personal data; and what choices and
            means of control you have over your personal data, please read this
            statement in its entirety.This privacy statement was last updated on
            January 31,2025.  If we make important changes to this privacy
            statement, we will post a notice on our website and/or contact our
            customers as appropriate or as required by applicable law.  ‍Table
            of ContentsWhat does this privacy statement cover?What personal,
            user and product data does COMPANY collect and how does COMPANY use
            and share the personal data it collects?Does COMPANY use cookies and
            related technologies on its websites?Does COMPANY collect personal
            data from children?How long does COMPANY retain the personal data it
            collects?Does COMPANY sell personal data?Does COMPANY transfer
            personal data across borders?How does COMPANY protect personal
            data?How can I review, correct, amend or delete my personal data?How
            can I contact COMPANY?What does this privacy statement cover?This
            statement describes COMPANY’s customer privacy practices for our
            COMPANY-branded global websites, COMPANY applications, COMPANY
            services, COMPANY customer sales and marketing activities, and
            COMPANY customer services and support functions, among others.  This
            statement does not apply to COMPANY’s employee data practices.Please
            also note that certain COMPANY websites, or software experiences may
            have links to third-party websites or services.  In most cases,
            those third-party resources are subject to the privacy practices and
            policies of those third parties and not COMPANY.What personal, user
            and product data does COMPANY collect and how does COMPANY use and
            share the personal data it collects?COMPANY may collect certain
            categories of data about you when you use our websites; use our
            services; receive our marketing communications; interact with our
            customer service and support teams; and in other contexts.  The data
            we collect can be broadly categorized as follows:Personal Data:
             This is individually identifiable data that you may choose to
            provide us.  This may include basic information such as your email
            address and phone number, or more sensitive information such as your
            full date of birth or your payment information.User Data:  This is
            data that we collect from users of our services.  User data could
            include personal data such as your unique COMPANY user ID or account
            username and password, but sometimes this user data is anonymous or
            “pseudonymous”, i.e., certain user data that could be made
            identifiable if associated with personal data.Location Data: This is
            data we collect that help us determine a location based on your IP
            address in order to customize our Service and for other uses
            consistent with this Privacy Statement.COMPANY has various uses for
            your personal and user data you provide to us.  Here are the
            principal contexts in which we may use, retain and share your
            personal and user data:Websites and Account Management:  Most often,
            you may browse our websites without providing any personal data to
            us.  However, if you choose to establish a user account with
            COMPANY, engage in e-commerce, sign up for marketing communications,
            or interact with our customer service teams or participate in a
            forum on our website, we will likely need to collect some personal
            or user data from you.  In addition, our web servers automatically
            collect certain data by default, such as IP addresses and other
            activity logs.  This type of data is used for website security and
            site improvement purposes.  Much of that data is not readily
            identifiable and is usually kept anonymous.  In order to maintain
            and improve our websites, COMPANY uses third party hosting, content
            management and security partners, vendors and suppliers.Sales: If
            you decide to purchase a service from COMPANY, we will need to
            collect certain personal data from you, including payment-related
            information.  Typically, we use third party partners, vendors and
            suppliers, such as payment processing companies during our
            sales.‍Marketing & Social Media:  You may choose to receive COMPANY
            marketing communications, participate in an event/contest/promotion
            with us, or connect with COMPANY via social media.  If you do so, we
            will collect certain personal data about you, such as your contact
            information, social media profile information and, in order to
            determine your eligibility for a contest or promotion, your full or
            partial dates of birth.  COMPANY may share your personal data with
            our marketing agencies and partners to carry out our marketing
            campaigns, contests and promotions.  If you wish to unsubscribe from
            our marketing, please follow the opt-out link in the communications
            you receive from us; update your contact preferences in your COMPANY
            account settings; or click here.Product Registration:  If you use
            COMPANY services, you may choose to establish an COMPANY user
            account. An COMPANY user account profile may include your username,
            password, settings, preferences, contact information, device ID
            information, and related data.  COMPANY may share this information
            with other COMPANY subsidiaries and affiliates and vendors and
            suppliers, such as third-party hosting partners.  Certain COMPANY
            product settings, preference information, applications history and
            location-based information may be used by COMPANY product
            development and improvement and customer service teams if you choose
            to enable enhanced customer support services.  Customer Service &
            Support:  If you choose to interact with COMPANY customer service
            and support – whether it be via our website, social media, chat,
            email or phone – COMPANY customer service teams (some of whom work
            for outsourced vendors and suppliers of COMPANY) may have access to
            your account information, product information, contact information
            and payment information.  You may also be required to answer certain
            security questions to verify your identity and your call or session
            with COMPANY customer support may be recorded for quality and
            training purposes.Job Opportunities:  You may choose to apply for
            employment opportunities at COMPANY through the COMPANY website.  If
            you complete an application for a job at COMPANY, we may collect
            your contact information, job history info and certain other
            information that may be required or allowed under applicable laws to
            screen candidates for employment.  We may share this information
            with other COMPANY subsidiaries and affiliates and vendors and
            suppliers who provide us with candidate search and hiring
            services.The following table provides further information on some of
            the specific types of personal or user data we may collect from you,
            how we use it and with whom we may share it:DATA COLLECTEDPURPOSES
            OF USETHIRD PARTIES WITH WHOM WE MAY SHARE ITFirst and Last
            NameAccount Management, Sales, Marketing & Social Media, Customer
            Service & Support; Job Applications and Employment ScreeningCOMPANY
            subsidiaries and affiliates; Vendors and Suppliers; Marketing
            agencies who handle campaigns on behalf of COMPANYContact
            Information (e.g., phone, email, mailing/billing/shipping
            address)Account Management, Sales, Marketing & Social Media,
            Customer Service & Support; Job Applications and Employment
            ScreeningCOMPANY subsidiaries and affiliates; Vendors and Suppliers;
            Marketing agencies who handle campaigns on behalf of COMPANYPayment
            Information (e.g., credit/debit card) Sales, Customer Service &
            SupportVendors and SuppliersUsername and PasswordAccount Management,
            Sales, Customer Service & SupportVendors and SuppliersFull/Partial
            Date of BirthSales,  Marketing & Social Media, Customer Service &
            Support; Job Applications and Employment ScreeningCOMPANY
            subsidiaries and affiliates; Vendors and Suppliers; Marketing
            agencies who handle campaigns/contests on behalf of COMPANYAnswers
            to Account Security QuestionsAccount Management, Customer Service &
            SupportVendors and SuppliersInternet Protocol (IP) AddressesWeb,
            Network and Product Security; Marketing & Social Media; Customer
            Service & SupportCOMPANY subsidiaries and affiliates; Vendors and
            SuppliersSocial Media Profile InformationMarketing & Social Media,
            Customer Service & SupportVendors and Suppliers; Marketing agencies
            who handle campaigns/contests on behalf of COMPANYEmployment
            Background and Screening InformationJob Applications and Employment
            ScreeningCOMPANY subsidiaries and affiliates; Vendors and
            SuppliersDoes COMPANY use cookies and related technologies on its
            websites?Cookies are small pieces of data that are sent to your
            browser from a web server and stored on your computer.  Websites,
            including COMPANY’s sites, use cookies to help remind us who you are
            when you visit our site; to help you navigate our site during your
            visits; and to save preferences and shopping cart contents for you
            so you will not have to re-enter them.COMPANY may also use cookies
            to store and help track information about you, including for online
            advertising purposes and specifically to determine which
            interest-based ads to display. Where required by applicable law,
            COMPANY will acquire consent from you prior to using certain cookies
            during your COMPANY website experience or will offer you the
            opportunity to choose which types of cookies to enable or disable.  
            To review or change your cookie preferences on our site, please
            click here.To serve and manage cookies, and related technologies
            such as tags and website data analytics tools, COMPANY may use
            products and services hosted by companies such as Google, Facebook
            and Twitter. These services may collect information, such as your IP
            address, sent by your browser or via cookies.The use of such cookies
            is relatively standard. Most browsers are initially set up to accept
            them. However, if you prefer not to store cookies, you can choose
            to:not use our sitesset your browser to notify you when you receive
            a cookieset your browser to refuse to accept cookiesupdate or change
            your cookie preferences through our website tool here.delete our
            cookies after visiting our sitebrowse our site using your browser’s
            anonymous usage setting (e.g., "Incognito" mode in Chrome)You should
            also understand that some features of the COMPANY website might not
            function properly if you do not accept cookies.If you do not know
            how to control or delete cookies or would like to opt-out of
            receiving certain targeted ads based on your browsing history, you
            may wish to visit https://www.networkadvertising.org/choices/,
            https://www.aboutads.info/, or https://www.youronlinechoices.eu/ for
            detailed guidance, including opt-out instructions.  If you would
            like to opt-out of certain third party supported Internet
            advertising and behavioral targeting services, please visit any of
            the following:GoogleFacebookTwitterAdobe Marketing CloudFor
            additional information:
             https://www.consumer.ftc.gov/articles/how-protect-your-privacy-onlineDoes
            COMPANY collect personal data from children?COMPANY’s websites,
            products and services are intended for adults aged 18 and older.
             Typically, if we become aware that we have collected personal data
            from persons aged 17 and under, we will take appropriate steps to
            delete and purge that data.  How long does COMPANY retain the
            personal data it collects?COMPANY intends to retain personal data
            only as long as necessary to complete the purposes of use described
            above in section 2.  When those purposes have been fulfilled, we
            will securely delete personal data as appropriate.  However, we may
            retain your personal data as long as any of the following
            circumstances apply:your COMPANY account or marketing subscription
            is activeto provide you with services or support that you have
            requestedto comply with applicable laws, including for tax and audit
            purposesto enforce COMPANY’s rights, including litigation and debt
            collectionDoes COMPANY sell personal data?While COMPANY may share
            personal data it collects pursuant to the purposes described above
            in section 2, COMPANY does not sell personal data.  If COMPANY did
            decide to sell personal data at any point, we would provide
            appropriate notice and consent mechanisms to individuals as required
            by applicable laws. In addition, please note that if COMPANY or any
            of its businesses or operations were to be sold to another entity at
            any point, that sale could involve the transfer of personal data
            held by COMPANY to the acquiring organization.  In such a
            circumstance, COMPANY would provide appropriate notice and consent
            mechanisms to individuals as required by applicable laws.Does
            COMPANY transfer personal data across borders?COMPANY may collect,
            process, use, retain and transfer personal data across borders in
            order to fulfill our purposes of use as described above in section
            2.  This may include transfers of personal data to countries that
            may not have equivalent privacy or data protection laws to those in
            your own country.  However, regardless of where we transfer personal
            data to, COMPANY takes appropriate steps to ensure that your
            personal data enjoys consistent standards of care.  This includes
            signing contracts between COMPANY affiliates and with our vendors
            and suppliers to make sure that both parties are following
            consistent privacy and security principles, processes and
            protections.For transfers involving European personal data, COMPANY
            uses Standard Contractual Clauses with its partners.  How does
            COMPANY protect personal data?COMPANY believes that privacy and
            security go hand-in-hand.  We use appropriate physical, technical,
            and administrative controls to protect the personal data we are
            responsible for.  That includes encryption and other enhanced
            security measures, where appropriate or required.  We also take
            appropriate steps to make sure that our vendors, suppliers and
            certain other partners adopt consistent standards of protection for
            the personal data that COMPANY is responsible for.   However, it is
            important to note that no technology is guaranteed to be
            invulnerable to threat or attack.  Therefore, please be sure to
            exercise care when using any website or product.  If technology you
            use is configured with privacy or security controls or features,
            please be sure to utilize those.How can I review, correct, amend or
            delete my personal data?In addition, under this privacy statement
            and certain applicable laws, you may submit a request to COMPANY to
            review, correct, amend or to delete your personal data that COMPANY
            has about you.  You may also have the right to request a
            machine-readable copy of your personal data. To submit such a
            request to COMPANY, please contact us at support@usenode.com .
            Please note that we will review, respond to and act upon such
            requests as soon as possible and in accordance with applicable laws.
             We are also required to verify your identity before granting you
            access to your personal data.  If you have an COMPANY account, we
            may verify your identity by requiring you to sign into your account.
            If you do not have an COMPANY account, or an email address on file
            with us, then we may request additional limited information from you
            in order to verify your identity. Please note that if you do not
            have an account with COMPANY, or an email address on file, or if we
            are unable to verify your identity in our records, we may deny your
            request.You may also use an authorized agent to submit a request
            under this section on your behalf. If you choose to have an
            authorized agent submit such a request on your behalf, COMPANY will
            require: (i) You to provide the authorized agent written permission
            to do so; and (ii) your agent to verify their identity directly with
            COMPANY.  COMPANY may deny a request from an agent that does not
            meet these requirements.In addition, you have the right to raise
            questions or complaints with your applicable national data
            protection authority at any time. How can I contact COMPANY?If you
            have any additional questions, complaints or concerns regarding
            privacy at COMPANY. Please feel free to reach us at the following:
             support@usenode.com   TERMS OF USE FOR NODE TECHNOLOGIES, INC. The
            following terms and conditions govern use of all content, services,
            and products (the “Service”) provided by NODE TECHNOLOGIES, INC.
            (“NODE”) and available on the NODE sites (the “Site”). The Service
            is owned and operated by NODE. The Site is intended to be used by
            companies (“Company(s)”) and customers (“Customers(s)” together with
            Companies “User” or “Users”) in connection with the Services.The
            Service is offered subject to your acceptance without modification
            of all of the terms and conditions contained herein and all other
            operating rules, policies, and procedures that may be published from
            time to time on the Site (collectively, the “Agreement”).If you are
            entering into this Agreement on behalf of a company or other legal
            entity, you represent that you have the authority to bind such
            entity, its affiliates, and all users who access the Service through
            your account to this Agreement, in which case the terms “you” or
            “your” shall refer to such entity, its affiliates, and users
            associated with it. If you do not have such authority, or if you do
            not agree with these terms and conditions, you must not accept this
            Agreement and may not use the Service.PLEASE READ THIS AGREEMENT
            CAREFULLY BEFORE ACCESSING OUR SITE OR USING THE SERVICE. BY
            ACCESSING OR USING ANY PART OF THE SITE, YOU AGREE TO BECOME BOUND
            BY THIS AGREEMENT. THESE TERMS INCLUDE A BINDING ARBITRATION CLAUSE
            AND A CLASS ACTION WAIVER. If you do not agree to all the terms and
            conditions of this Agreement, then you may not access the Service.
            If these terms and conditions are considered an offer by NODE,
            acceptance is expressly limited to these terms.NODE AND ITS SITE IS
            A PLATFORM AND IS NOT A PARTY TO ANY SERVICES AGREEMENT OR OTHER
            TRANSACTION BETWEEN USERS OF THE SITE.NODE acts as a venue for Users
            of the Site to view and post services on the Site. NODE is not a
            party to any actual agreement or transaction between Users even
            though we may from time to time provide tools that relate to such
            transaction, such as a tool to enable payment for services. As a
            result, NODE has no control over the accuracy or correctness of the
            content or information provided or used by such Companies and
            Customers. Any part of an actual or potential transaction between a
            Company and a Customer, including the condition, quality, safety of
            the services advertised, the truth or accuracy of the service
            (including the content thereof or any review related thereto), the
            ability of Companies to provide services, or the ability of
            Customers to pay for services are solely the responsibility of each
            User. Separate Agreements. Users acknowledge and agree that you will
            be required to enter into a separate agreement and/or waiver,
            directly between the Company and Customer, prior to purchasing a
            product or service and such agreement and/or waiver may place
            additional restrictions on your product, or service. Any separate
            agreements and/or waivers relating to the products or services are
            under the sole control of any Company and Customer.General Account
            TermsYou must be a human. Accounts registered by “bots” or other
            automated methods are not permitted.Each account may be only used by
            one person and you may only have one account. If it is discovered
            that you have registered multiple accounts, are sharing accounts
            with another individual, or are otherwise accessing the Site through
            an account that is not your own, all accounts affected by such use
            shall be terminated.You are responsible for maintaining the security
            of your account and password. NODE cannot and will not be liable for
            any loss or damage from your failure to comply with this security
            obligation. You are fully responsible for all activities that occur
            under the account and any other actions taken in connection with the
            account. You must immediately notify NODE of any unauthorized uses
            of your account, or any other breaches of security. NODE will not be
            liable for any acts or omissions by you, including any damages of
            any kind incurred as a result of such acts or omissions. You may not
            use the Service for any illegal or unauthorized purpose. You must
            not, in the use of the Service, violate any laws in your
            jurisdiction (including but not limited to copyright or trademark
            laws). No matter what else is said in these Terms or anywhere else
            within the Services, you expressly acknowledge that you have no
            right, title, or interest to or in any account you create through
            our Services, and your account is not your property.By using the
            Site, you warrant and represent that you are at least 18 years of
            age and otherwise legally competent to read, understand and accept
            the provisions of this Agreement. If you are under 18 years of age,
            you must not use any part of the Site, create an account, or submit
            any personal information to NODE through the Site. NODE may remove
            Content that violates the Agreement at its sole discretion. Removing
            Content, or terminating an account are not actions NODE take
            lightly, and we may take a while to investigate and determine if
            such actions are warranted. It is at NODE’s sole discretion whether
            to discuss the reasons for taking action against any Content or
            account.CommunicationBy using this Site and our services you give
            NODE your express permission to contact you via email, messaging, or
            other electronic or non-electronic forms of communication for all
            purposes including distribution of marketing and promotional
            materials.We provide interactive services on our Site, including,
            without limitation chat rooms and bulletin boards. We will take
            reasonable endeavours to assess any possible risks for Users from
            third parties when they use any interactive service provided on our
            Site, and we will decide in each case whether it is appropriate to
            use moderation of the relevant Service (including what kind of
            moderation to use) in the light of those risks. However, we are
            under no obligation to oversee, monitor or moderate any interactive
            service we provide on our Site, and we expressly exclude our
            liability for any loss or damage arising from the use of any
            interactive service by a user in contravention of our content
            standards, whether the Service is moderated or not. Should a
            difficulty arise, the user should contact us by emailing
            support@usenode.com immediately.ContentIf you make (or allow any
            third party to make) material available through the Site (any such
            material, “Content”), you are entirely responsible for the content
            of, and any harm resulting from, that Content. That is the case
            regardless of whether the Content in question constitutes text,
            graphics, an audio file, or computer software.A. By making Content
            available, you represent and warrant that:the downloading, copying,
            and use of the Content will not infringe the proprietary rights,
            including but not limited to the copyright, patent, trademark, or
            trade secret rights, of any third party;if your employer has rights
            to intellectual property you create, you have either (i) received
            permission from your employer to post or make available the Content,
            including but not limited to any software, or (ii) secured from your
            employer a waiver as to all rights in or to the Content;you have
            fully complied with any third-party licenses relating to the
            Content, and have done all things necessary to successfully pass
            through to end users any required terms;the Content does not contain
            or install any viruses, worms, malware, trojan horses, or other
            harmful or destructive content;the Content is not spam, is not
            machine- or randomly-generated, and does not contain unethical or
            unwanted commercial content designed to drive traffic to third party
            sites or boost the search engine rankings of third party sites, or
            to further unlawful acts (such as phishing) or mislead recipients as
            to the source of the material (such as spoofing);the Content is not
            pornographic, does not contain threats or incite violence, and does
            not violate the privacy or publicity rights of any third party;the
            Content is not getting advertised via unwanted electronic messages
            such as spam links on newsgroups, email lists, other groups and web
            sites, and similar unsolicited promotional methods;the Content is
            not named in a manner that misleads your readers into thinking that
            you are another person or company; andyou have, in the case of
            Content that includes computer code, accurately categorized and/or
            described the type, nature, uses, and effects of the materials,
            whether requested to do so by NODE or otherwise.B. Without limiting
            any of those representations or warranties, NODE has the right
            (though not the obligation) to, in NODE’s sole discretion:refuse or
            remove any content that, in NODE’s reasonable opinion, violates any
            NODE policy or is in any way harmful or objectionable, orterminate
            or deny access to and use of the Service to any individual or entity
            for any reason. NODE will have no obligation to provide a refund of
            any amounts previously paid.As a User, you may deactivate your
            account at any time. Personally identifying information such as your
            name, username, and profile photo will no longer be associated with
            Content you have posted. Our Fees You agree to pay NODE the fees
            indicated for the Service. Refunds All of the fees are not
            non-refundable. Requests for refunds will be reviewed and determined
            on a case by case basis. NODE reserves the right, in its reasonable
            discretion, to refuse to refund fees.PaymentsIn order to use certain
            Site Services, you must provide account information for at least one
            valid payment method.You hereby authorize NODE, to run credit card
            authorizations on all credit cards provided by you, to store credit
            card and banking or other financial details as your method of
            payment consistent with our Customer Privacy Statement, and to
            charge your credit card (or any other payment method) for the Fees
            and any other amounts owed under the Agreement. To the extent
            permitted by applicable law and subject to our Customer Privacy
            Statement, you acknowledge and agree that we may use certain
            third-party vendors and service providers to process payments and
            manage your payment method information.By providing payment method
            information through the Site and authorizing payments with the
            payment method, you represents, warrants, and covenants that: (a)
            you are legally authorized to provide such information; (b) you are
            legally authorized to make payments using the payment method(s); (c)
            if you are an employee or agent of a company or person that owns the
            payment method, you are authorized by the company or person to use
            the payment method to make payments; and (d) such actions do not
            violate the terms and conditions applicable to your use of such
            payment method(s) or applicable law.Copyright PolicyNODE respects
            copyright law and expects its users to do the same. It is NODE’s
            policy to terminate in appropriate circumstances users or other
            account holders who repeatedly infringe or are believed to be
            repeatedly infringing the rights of copyright holders.NODE
            Intellectual Property OwnershipThe Services contain proprietary
            materials such as logos, text, software, photos, video, graphics,
            music and sound. NODE is the owner or licensee of all such
            proprietary material and all intellectual property rights therein,
            including without limitation, copyrights and trademarks. In using
            the Services, you agree not to upload, download, distribute, or
            reproduce in any way any such proprietary materials without
            obtaining NODE’s prior consent. BySoftware License Terms We Own the
            SoftwareNode’s systems and software (“Software”) (including any
            releases, revisions, updates or enhancements to the Software) and
            any documentation that accompanies or is made available in
            connection with Software (including any subscription or purchase
            information, product packaging) (the “Documentation”), is owned by
            NODE or its licensors. This includes all Intellectual Property
            Rights in and to the Software and Documentation. Any Software that
            NODE provides to you is licensed, not sold to you, and NODE reserves
            all rights to the Software not expressly granted in these Software
            License Terms.So long as you comply with the terms and conditions of
            the Agreement, NODE grants to you a limited non-exclusive,
            non-transferable license, with no right to sublicense, to download
            and install a copy of the Software on a mobile device, computer or
            tablet that you own or control and to run such copy of the Software
            solely for purposes of accessing and using the Services where the
            corresponding Services are available for your use during the
            applicable subscription period.You may not: (i) copy, modify or
            create derivative works based on the Software; (ii) distribute,
            transfer, sublicense, lease, lend or rent the Software to any third
            party; (iii) reverse engineer, decompile or disassemble the
            Software; or (iv) make the functionality of the Software available
            to third parties, except and only to the extent that applicable law
            expressly permits.These Terms allow you to install only one copy of
            the Software for use on a single computer, mobile device or tablet,
            unless your subscription to the Services expressly permits you to
            use Software on more than one device. You may make one copy of the
            Software for back-up or archival purposes or copy the Software onto
            the hard disk of your device and retain the original for back-up or
            archival purposes only.Upon expiration or any termination of these
            Terms, you must stop using and destroy all copies of the Software
            and the Documentation in your possession.There may be technological
            measures in the Software that are designed to prevent unlicensed or
            illegal use of the Software. You agree that NODE may use these
            measures to protect NODE against Software piracy (e.g. the software
            may contain enforcement technology that limits the ability to
            install and uninstall the Software on a device to not more than a
            finite number of times for a finite number of devices). You may need
            to activate these technological measures. If so, the Software will
            only operate for a finite period prior to Software activation by
            you. During activation, you may be required to provide a unique
            activation code accompanying the Software and device configuration
            in the form of an alphanumeric code over the internet to verify the
            authenticity of the Software. If you do not complete the activation
            within the finite period or as prompted by the Software, the
            Software will cease to function until activation is complete; at
            which time the Software functionality will be restored. If you are
            not able to activate the Software during the activation process, you
            may contact NODE using the information provided during activation or
            by the provider of the Software.ChangesWe reserve the right to
            modify the Agreement at any time and modified terms are effective
            upon posting to the Site. We will make reasonable efforts to inform
            you of these changes via email or through the Service. Your
            continued use of or access to the Service following the posting of
            any changes to this Agreement constitutes acceptance of those
            changes. NODE may also, in the future, offer new services and/or
            features including the release of new tools and resources. Such new
            features and/or services shall be subject to the terms and
            conditions of this Agreement.DataUsers may request data related to
            their personal account and group(s) respectively. NODE has the right
            to refuse repetitive or technically difficult requests. For
            information about how we collect and share user information please
            refer to our Customer Privacy Statement.Disclaimer of WarrantiesTHE
            SERVICE IS PROVIDED “AS IS” AND "AS AVAILABLE". NODE AND ITS
            OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, SUBSIDIARIES, AFFILIATES,
            LICENSORS AND SUPPLIERS HEREBY EXPRESSLY DISCLAIM ALL WARRANTIES OF
            ANY KIND, EXPRESS OR IMPLIED, INCLUDING, WITHOUT LIMITATION, THE
            IMPLIED WARRANTIES OF TITLE, MERCHANTABILITY, NON-INFRINGEMENT, AND
            FITNESS FOR A PARTICULAR PURPOSE. NEITHER NODENOR ITS OFFICERS,
            DIRECTORS, EMPLOYEES, AGENTS, SUBSIDIARIES, AFFILIATES, LICENSORS
            NOR SUPPLIERS WARRANT THAT THE OPERATION OF THE SERVICE WILL BE
            UNINTERRUPTED, ERROR FREE OR WITHOUT BREACHES OF SECURITY.NODE, ITS
            OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, SUBSIDIARIES, AFFILIATES,
            AND ITS LICENSORS DO NOT REPRESENT OR WARRANT THAT:THE INFORMATION
            PROVIDED ON SITE IS TRUE OR CORRECT,YOUR USE OF THE SERVICES WILL
            MEET YOUR REQUIREMENTS OR EXPECTATIONS,YOUR USE OF THE SERVICES WILL
            BE UNINTERRUPTED, TIMELY, SECURE OR FREE FROM ERROR,ANY INFORMATION
            OBTAINED BY YOU AS A RESULT OF YOUR USE OF THE SERVICES WILL BE
            ACCURATE OR RELIABLE, ORTHAT DEFECTS IN THE OPERATION OR
            FUNCTIONALITY OF ANY SOFTWARE PROVIDED TO YOU AS PART OF THE
            SERVICES WILL BE CORRECTED.Limitation of LiabilityIN NO EVENT WILL
            NODE ITS OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, SUBSIDIARIES OR
            AFFILIATES BE LIABLE TO ANY PARTY FOR:ANY DIRECT, INDIRECT,
            INCIDENTAL, CONSEQUENTIAL, SPECIAL, EXEMPLARY, OR PUNITIVE, DAMAGES
            ARISING OUT OF THE USE, AVAILABILITY OR UNAVAILABILITY OF THE
            SERVICES (INCLUDING BUT NOT LIMITED TO THE UNAVAILABILITY OR CHANGE
            IN ADVERTISED SERVICES) OR ANY OTHER SERVICES OR GOODS OBTAINED
            THROUGH USE OF ANY OF THE FOREGOING, OR ANY DATA TRANSMITTED THROUGH
            THE SERVICE, EVEN IF NODE HAS BEEN ADVISED OF THE POSSIBILITY OF
            SUCH DAMAGES; ANDANY LOSS OR DAMAGE WHICH MAY BE INCURRED BY YOU,
            INCLUDING BUT NOT LIMITED TO LOSS OR DAMAGE AS A RESULT OF:ANY
            RELIANCE PLACED BY YOU ON THE COMPLETENESS, ACCURACY OR EXISTENCE OF
            ANY ADVERTISING, OR AS A RESULT OF ANY RELATIONSHIP OR TRANSACTION
            BETWEEN YOU AND ANY ADVERTISER OR SPONSOR WHOSE ADVERTISING APPEARS
            ON THE SERVICES;ANY CHANGES WHICH NOD EMAY MAKE TO THE SERVICES, OR
            FOR ANY PERMANENT OR TEMPORARY CESSATION IN THE PROVISION OF THE
            SERVICES (OR ANY FEATURES WITHIN THE SERVICES);YOUR FAILURE TO
            PROVIDE NODE WITH ACCURATE INFORMATION;YOUR FAILURE TO KEEP YOUR
            PASSWORD OR ACCOUNT DETAILS SECURE AND CONFIDENTIAL.ANY BODILY
            INJURY, DEATH, OR PROPERTY DAMAGE THAT MAY OCCUR AS THE RESULT OF
            SERVICES. ‍NOTWITHSTANDING THE TERMS, IN NO EVENT SHALL NODE BE HELD
            LIABLE, FOR ANY AMOUNTS IN EXCESS OF (IN THE AGGREGATE) ONE HUNDRED
            U.S. DOLLARS ($100.00).  NODE SHALL HAVE NO LIABILITY FOR ANY
            FAILURE OR DELAY DUE TO MATTERS BEYOND THEIR REASONABLE CONTROL. THE
            FOREGOING SHALL NOT APPLY TO THE EXTENT PROHIBITED BY APPLICABLE
            LAW.IndemnificationYou agree to indemnify, release, defend and hold
            harmless NODE and its directors, officers, agents and employees
            (collectively, the “NODE parties”) from any claims, causes of
            action, demands, recoveries, losses, damages (actual and
            consequential), fines, penalties and other costs or expenses, of any
            kind or nature, including but not limited to reasonable legal and
            accounting fees (collectively, the “claims”), known and unknown,
            arising out of or in any way connected with such disputes,
            including, without limitation, disputes arising over breach of this
            agreement, breach of any separate agreement or transaction, and/or
            the substitution of units. Further, you hereby agree to indemnify,
            release, defend and hold harmless the NODE parties from any claims
            brought as a result of your (1) breach of the terms, (2) violation
            of any law or the rights of a third party, and (3) use of this Site
            and the Services. Disputes ResolutionThis Agreement constitutes the
            entire agreement between NODEcand you concerning the subject matter
            hereof, and they may only be modified by a written amendment signed
            by an authorized agent/employee of COMPANY, or by the posting by
            NODEcof a revised version. Any and all disputes arising of this
            Agreement, termination, or our relationship with you shall be
            determined by applying laws of the State of Delaware. If any part of
            this Agreement is held invalid or unenforceable, that part will be
            struck, and the remaining portions will remain in full force and
            effect. A waiver by either party of any term or condition of this
            Agreement or any breach thereof, in any one instance, will not waive
            such term or condition or any subsequent breach thereof. You may not
            assign your rights under this Agreement without written consent from
            NODE; NODE may assign its rights under this Agreement without
            condition. This Agreement will be binding upon and will inure to the
            benefit of the parties, their successors and permitted
            assigns.ARBITRATION Dispute resolution and arbitrationBy using this
            Site, you agree that any and all disputes, claims or controversies
            that you may have against NODE arising out of or relating to or
            connected in any way to (i) your use of this Site (ii) any services
            obtained from or provided by NODE or (iii) this Agreement (including
            the interpretation and scope of this clause and the arbitrability of
            the dispute), shall be resolved exclusively by mandatory, binding
            arbitration initiated through and administered by the American
            Arbitration Association ("AAA"). You further agree that arbitration
            will be conducted by a single arbitrator pursuant to the applicable
            Rules and Procedures established by AAA, and that any arbitration
            proceeding, if necessary, will be held in Montréal, Canada or at
            such other location as may be mutually agreed upon by NODE and you.
            Arbitration will be subject to the Federal Arbitration Act and not
            any state arbitration law. The arbitrator shall apply Montréal,
            Canada law consistent with the Federal Arbitration Act, and shall
            honor claims of privilege recognized at law. In order to initiate
            arbitration with the AAA, you may be responsible for paying a filing
            fee to the AAA, however, in the event you are able to demonstrate
            that the costs of arbitration will be prohibitive as compared to the
            costs of litigation, NODE will reimburse as much of your filing and
            hearing fees in connection with the arbitration as the arbitrator
            deems necessary to prevent the arbitration from being
            cost-prohibitive. There will be no right or authority for any claims
            to be arbitrated on a class action or representative basis. YOU
            UNDERSTAND AND AGREE THAT, BY ACCEPTING THESE TERMS AND CONDITIONS,
            YOU AND NODE ARE EACH WAIVING THE RIGHT TO A TRIAL BY JURY OR TO
            PARTICIPATE IN A CLASS ACTION WITH RESPECT TO THE CLAIMS COVERED BY
            THIS MANDATORY ARBITRATION PROVISION. You are thus giving up your
            right to go to court to assert or defend your rights. Your rights
            will be determined by a neutral arbitrator, and not a judge or
            jury.All claims you bring against NODE must be resolved in
            accordance with this arbitration provision. All claims filed or
            brought by you contrary to this provision will be considered
            improperly filed and void. Should you file a claim contrary to this
            arbitration provision, NODE will notify you in writing of the
            improperly filed claim, and you must promptly withdraw the claim.
             If you fail to promptly withdraw the claim after receiving written
            notice from NODE, NODE may recover its reasonable attorneys’ fees
            and costs incurred to enforce this arbitration provision.Notice;
            ProcessA party who intends to seek arbitration must first send a
            written notice of the dispute to the other, by certified mail,
            Federal Express, UPS, or Express Mail (signature required), or in
            the event that we do not have a physical address on file for you, by
            electronic mail ("Notice"). NODE's address for Notice is:
            support@usenode.com.The Notice must (1) describe the nature and
            basis of the claim or dispute; and (2) set forth the specific relief
            sought ("Demand"). We agree to use good faith efforts to resolve the
            claim directly, but if we do not reach an agreement to do so within
            30 days after the Notice is received, you or NODE may commence an
            arbitration proceeding. During the arbitration, the amount of any
            settlement offer made by you or NODE shall not be disclosed to the
            arbitrator until after the arbitrator makes a final decision and
            award, if any. All documents and information disclosed in the course
            of the arbitration shall be kept strictly confidential by the
            recipient and shall not be used by the recipient for any purpose
            other than for purposes of the arbitration or the enforcement of the
            arbitrator’s decision and award and shall not be disclosed except in
            confidence to persons who have a need to know for such purposes or
            as required by applicable law.EnforceabilityIf any part of this
            arbitration provision is deemed to be invalid, unenforceable or
            illegal, or otherwise conflicts with the Rules and Procedures
            established by AAA, then the balance of this arbitration provision
            shall remain in effect and shall be construed in accordance with its
            terms as if the invalid, unenforceable, illegal or conflicting
            provision was not contained herein.Miscellaneous General Compliance
            with LawsYou shall comply with all applicable laws, statutes,
            ordinances and regulations regarding your use of the
            Services.HeadingsHeadings are for reference purposes only and in no
            way define, limit, construe or describe the scope or extent of such
            section.Entire Agreement This Agreement constitutes the entire
            agreement between NODE and you concerning the subject matter hereof,
            and they may only be modified by a written amendment signed by an
            authorized agent/employee of NODE, or by the posting by NODE of a
            revised version. Governing LawThe terms of this Agreement shall be
            construed in accordance with the substantive laws of the State of
            Delaware, United States of America, without giving effect to the
            principles of conflict or choice of law of such state. The original
            form of this Agreement has been written in English. The parties
            hereto waive any statute, law, or regulation that might provide an
            alternative law or forum or might require this Agreement to be
            written in any language other than English. This Agreement expressly
            excludes the United Nations Convention on Contracts for the
            International Sale of Goods.SeverabilityIf any part of this
            Agreement is held invalid or unenforceable, that part will be
            struck, and the remaining portions will remain in full force and
            effect.WaiverA waiver by either party of any term or condition of
            this Agreement or any breach thereof, in any one instance, will not
            waive such term or condition or any subsequent breach thereof.
            Assignment You may not assign your rights under this Agreement
            without written consent from NODE; NODE may assign its rights under
            this Agreement without condition. This Agreement will be binding
            upon and will inure to the benefit of the parties, their successors
            and permitted assigns.TerminationNODE may immediately issue a
            warning, temporarily suspend, indefinitely suspend or terminate your
            use of all or any portion of the Services if you breach the Terms,
            or at any time or for any reason, at the sole discretion of NODE.No
            RelationshipNo joint venture, partnership, employment, or agency
            relationship exist between you, NODE or any third party provider as
            a result of this Agreement or use of the Service. Force Majeure NODE
            shall not be liable for any delay or failure to perform in
            connection with any Services, Service or in the performance of any
            obligation hereunder, if such delay or failure is due to or in any
            manner caused by acts of God, rebellion, riots, hijacking,
            insurrection, civil commotion, strikes or labor disputes, fires,
            floods, laws, regulations, acts, demands or and orders of any
            government or agency, or any other cause which is beyond the control
            of NODE. NODE is hereby released by you from any claim or demand for
            any direct or consequential damages arising out of failure to
            perform as a result of a force majeure event whether or not herein
            enumerated or other event referenced above.Contacting COMPANY If you
            have any questions about these Terms of Service, please contact NODE
            at support@usenode.com.    
          </Typography>
        </Box>
      </Container>
    </WebsiteLayout>
  );
};

export default LegalTerms;
